(function () {
  document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('[data-quiz-root]');
    const intro = document.querySelector('[data-quiz-intro]');
    const introButton = document.querySelector('[data-quiz-intro-continue]');
    const backButton = document.querySelector('[data-quiz-back]');
    const progressText = document.querySelector('[data-quiz-progress-text]');
    const progressBarFill = document.querySelector('[data-quiz-progress-bar]');
    const headerSection = document.getElementById('shopify-section-header');
if (headerSection) {
  headerSection.style.display = 'none';
}

    if (!root) return;

    if (!document.getElementById('quiz-btn-flex-fix')) {
  const s = document.createElement('style');
  s.id = 'quiz-btn-flex-fix';
  s.textContent = `
    .xo-quiz-button {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      gap: 8px !important;
      line-height: 1 !important;
    }
    .xo-quiz-button svg {
      flex-shrink: 0;
      display: block;
    }
  `;
  document.head.appendChild(s);
}

// --- Social Snowball referral detection (session scoped) ---
function isSnowballFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const utm = (params.get('utm_source') || '').toLowerCase();
  return utm === 'snowball' || params.has('snowball');
}

const snowballNow = isSnowballFromUrl();

// If the customer lands via Snowball, remember it for this browser tab only.
if (snowballNow) {
  sessionStorage.setItem('snowball_ref', '1');
}

// Snowball is active if:
// 1. Current URL contains the referral params, OR
// 2. This browsing session previously came from Snowball.
const FROM_SNOWBALL =
  snowballNow || sessionStorage.getItem('snowball_ref') === '1';
    // ---------- CONFIG ----------
       const QUIZ_CATEGORY = 'weight';
    const QUIZ_ENDPOINT = 'https://script.google.com/macros/s/AKfycbzxCq_Y44zC-vE8GsPbM0PE-E1GohjmQ5ssDo7n4B7Ija78sP0AeUCeUmspI58PVp8/exec';
    const WEIGHT_STEP_PROGRESS = [
  8,   // height_weight
  13,  // journey
  17,  // reasons
  21,  // past_methods
  25,  // info_feel_better
  29,  // email
  33,  // sex_at_birth
  38,  // current_situation
  46,  // ethnicity
  50,  // info_medical_history
  54,  // using_medication
  58,  // which_medication
  63,  // other_conditions
  71,  // eating_disorder
  79,  // other_medical
  83,  // regular_meds
  88,  // allergies
  92,  // gp_details
  96   // dob
];


// Optional version label (handy in Apps Script logs)
const QUIZ_VERSION = QUIZ_CATEGORY + '_v1';

// ---------- PRODUCT CONFIG ----------
const TREATMENT_PRODUCTS = {
  mounjaro: {
    id: 'mounjaro',
    handle: 'mounjaro',
    nameHtml: 'Mounjaro<sup>®</sup>',
    image: 'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/Trim_Mounjaro_2_5mg_weight_loss_injection_png.png?v=1768558987',
    modalImage: 'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/cheap_Mounjaro_weight_loss_injection.png?v=1769091242',
    price: '£195/month',
    doseCopy: '1x pen every 28 days. Pause or cancel anytime.',
    tags: [
      { variant: 'primary', label: 'Most effective' },
      { variant: 'secondary', label: 'In stock' }
    ],
    status: 'in_stock',
    startingStrengthId: 'mounjaro-2-5',
    strengths: [
      {
        id: 'mounjaro-2-5',
        handle: 'mounjaro-kwikpen-2-5mg-0-6ml-solution-for-injection-2-4ml-pre-filled-pens',
        label: '2.5 mg – £195',
        isStarting: true,
        variantId: 48556556583235,
        sellingPlanId: 690249236803,
        priceText: '£195/month',
        heroImage: 'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/Trim_Mounjaro_2_5mg_weight_loss_injection_png.png?v=1768558987'
      },
      {
        id: 'mounjaro-5',
        handle: 'mounjaro-kwikpen-5mg-0-6ml-solution-for-injection-2-4ml-pre-filled-pens',
        label: '5 mg – £225',
        isStarting: false,
        variantId: 48218878738755,
        sellingPlanId: 690249236803,
        priceText: '£225/month',
        heroImage: 'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/Trim_Mounjaro_5mg_weight_loss_injection_png_png_png.png?v=1768387113'
      },
      {
        id: 'mounjaro-7-5',
        handle: 'mounjaro-kwikpen-7-5mg-0-6ml-solution-for-injection-2-4ml-pre-filled-pens',
        label: '7.5 mg – £265',
        isStarting: false,
        variantId: 48556615663939,
        sellingPlanId: 690249236803,
        priceText: '£265/month',
        heroImage: 'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/Trim_Mounjaro_7_5mg_weight_loss_injection_png_png_png.png?v=1768387113'
      },
      {
        id: 'mounjaro-10',
        handle: 'mounjaro-kwikpen-10mg-0-6ml-solution-for-injection-2-4ml-pre-filled-pens',
        label: '10 mg – £295',
        isStarting: false,
        variantId: 48556687851843,
        sellingPlanId: 690249236803,
        priceText: '£295/month',
        heroImage: 'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/Trim_Mounjaro_10mg_weight_loss_injection_png_png_png.png?v=1768387112'
      },
      {
        id: 'mounjaro-12-5',
        handle: 'mounjaro-kwikpen-12-5mg-0-6ml-solution-for-injection-2-4ml-pre-filled-pens',
        label: '12.5 mg – £325',
        isStarting: false,
        variantId: 48218888929603,
        sellingPlanId: 690249236803,
        priceText: '£325/month',
        heroImage: 'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/Trim_Mounjaro_12_5mg_weight_loss_injection_png_png_png.png?v=1768387112'
      },
      {
        id: 'mounjaro-15',
          handle: 'mounjaro-kwikpen-15mg-0-6ml-solution-for-injection-2-4ml-pre-filled-pens',
        label: '15 mg – £325',
        isStarting: false,
        variantId: 48218892697923,
        sellingPlanId: 690249236803,
        priceText: '£325/month',
        heroImage: 'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/Trim_Mounjaro_15mg_weight_loss_injection_png_png_png.png?v=1768387103'
      }
    ],
    accordions: [
      { title: 'How it works', content: 'Mounjaro works by mimicking hormones that target areas of the brain involved in regulating appetite and food intake.' },
      { title: 'Dose schedule', content: 'Taken once weekly via injection.' },
      { title: 'How to take', content: 'Inject under the skin (subcutaneously) in your stomach, thigh, or upper arm.' },
      { title: 'Potential common side effects', content: 'Nausea, diarrhoea, constipation, stomach (abdominal) pain.' },
      { title: 'Important safety information', content: 'Do not use if you have a personal or family history of Medullary Thyroid Carcinoma (MTC).' }
    ]
  },

  wegovy: {
    id: 'wegovy',
    nameHtml: 'Wegovy<sup>®</sup>',
    tags: [
      { variant: 'primary', label: 'Cost effective' },
      { variant: 'secondary', label: 'In stock' }
    ],
    status: 'in_stock',

    // default view for the modal card
    defaultForm: 'injection',

    forms: {
injection: {
        id: 'wegovy-injection',
        label: 'Injection',
        subtitle: 'Semaglutide · Weekly injection · Up to 15% weight loss',
        price: 'Starting at £149.00',
        image: 'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/Trim_Wegovy_0_25mg_weight_loss_injection_png_png.png?v=1768387113',
        modalImage: 'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/cheap_Wegovy_weight_loss_injection.png?v=1769091227',
        doseCopy: '1x pen every 28 days. Pause or cancel anytime.',
        tags: [
          { variant: 'primary', label: 'Cost effective' },
          { variant: 'secondary', label: 'In stock' }
        ],
          startingStrengthId: 'wegovy-0-25',
        tags: [
          { variant: 'primary', label: 'Cost effective' },
          { variant: 'secondary', label: 'In stock' }
        ],
        status: 'in_stock',
      
       strengths: [
          {
            id: 'wegovy-0-25',
            handle: 'wegovy',
            label: '0.25 mg – £129',
            isStarting: true,
            variantId: 48557180846403,
            sellingPlanId: 690249236803,
            priceText: '£129/month',
            heroImage: 'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/Trim_Wegovy_0_25mg_weight_loss_injection_png_png.png?v=1768387113'
          },
          {
            id: 'wegovy-0-5',
            handle: 'wegovy-flextouch-0-5mg-0-37ml-solution-for-injection-1-5ml-pre-filled-pens',
            label: '0.5 mg – £165',
            isStarting: false,
            variantId: 48187619639619,
            sellingPlanId: 690249236803,
            priceText: '£165/month',
            heroImage: 'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/Trim_Wegovy_0_5mg_weight_loss_injection_png.png?v=1768387113'
          },
          {
            id: 'wegovy-1-0',
            handle: 'wegovy-flextouch-1mg-0-75ml-solution-for-injection-3ml-pre-filled-pens',
            label: '1.0 mg – £185',
            isStarting: false,
            variantId: 48187677376835,
            sellingPlanId: 690249236803,
            priceText: '£185/month',
            heroImage: 'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/Trim_Wegovy_1mg_weight_loss_injection_png_png.png?v=1768387112'
          },
          {
            id: 'wegovy-1-7',
            handle: 'wegovy-flextouch-1-7mg-0-75ml-solution-for-injection-3ml-pre-filled-pens',
            label: '1.7 mg – £225',
            isStarting: false,
            variantId: 48187718336835,
            sellingPlanId: 690249236803,
            priceText: '£225/month',
            heroImage: 'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/Trim_Wegovy_1_7mg_weight_loss_injection_png_png.png?v=1768387113'
          },
          {
            id: 'wegovy-2-4',
            handle: 'wegovy-flextouch-2-4mg-0-75ml-solution-for-injection-3ml-pre-filled-pens',
            label: '2.4 mg – £255',
            isStarting: false,
            variantId: 48187763556675,
            sellingPlanId: 690249236803,
            priceText: '£255/month',
            heroImage: 'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/Trim_Wegovy_2_4mg_weight_loss_injection_png_png.png?v=1768387114'
          }
        ]
      },

pill: {
        id: 'wegovy-pill',
        label: 'Pill',
        subtitle: 'Semaglutide · Once-daily tablet · Up to 14% weight loss',
        price: 'Starting at £129',
        image: 'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/17_aed9723a-5fea-41c4-8ceb-1bd0cd3e81d7.png?v=1780304134',
        modalImage: 'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/17_aed9723a-5fea-41c4-8ceb-1bd0cd3e81d7.png?v=1780304134',
        doseCopy: 'Taken once daily. Pause or cancel anytime.',
        tags: [
          { variant: 'primary', label: 'No injection' },
          { variant: 'secondary', label: 'In stock' }
        ],
         startingStrengthId: 'wegovy-pill-1-5',
        tags: [
          { variant: 'primary', label: 'No injection' },
          { variant: 'secondary', label: 'In stock' }
        ],
 status: 'in_stock',
       
        strengths: [
          {
            id: 'wegovy-pill-1-5',
            handle: 'wegovy-oral-tablet',
            label: '1.5 mg – £129',
            isStarting: true,
            variantId: 54484713242947,
            sellingPlanId: 690249236803,
            priceText: '£129/month',
            heroImage: 'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/Wegovy_tablets_1.5mg_trim.png?v=1779204033'
          },
          {
            id: 'wegovy-pill-4',
            handle: 'wegovy-4mg-tablets-30',
            label: '4 mg – £165',
            isStarting: false,
            variantId: 54490597687619,
            sellingPlanId: 690249236803,
            priceText: '£165/month',
            heroImage: 'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/Wegovy_tablets_4mg_trim.png?v=1779204033'
          },
          {
            id: 'wegovy-pill-9',
            handle: 'wegovy-9mg-tablets-30',
            label: '9 mg – £185',
            isStarting: false,
            variantId: 54490599719235,
            sellingPlanId: 690249236803,
            priceText: '£185/month',
            heroImage: 'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/Wegovy_tablets_9mg_trim.png?v=1779204034'
          },
          {
            id: 'wegovy-pill-25',
            handle: 'wegovy-25mg-tablets-30',
            label: '25 mg – £225',
            isStarting: false,
            variantId: 54490600079683,
            sellingPlanId: 690249236803,
            priceText: '£225/month',
            heroImage: 'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/Wegovy_tablets_25mg_trim.png?v=1779204034'
          }
        ]
      }
    },

    accordions: [
      { title: 'How it works', content: 'Wegovy works by mimicking a single hormone that targets areas of the brain that regulate appetite and food intake.' },
      { title: 'Dose schedule', content: 'Taken once Daily via injection or once daily as a tablet, depending on the selected form.' },
      { title: 'How to take', content: 'Inject under the skin for injection form, or swallow the tablet form as directed.' },
      { title: 'Potential common side effects', content: 'Nausea, diarrhoea, constipation, stomach (abdominal) pain.' },
      { title: 'Important safety information', content: 'Do not use if you have a personal or family history of Medullary Thyroid Carcinoma (MTC).' }
    ]
  },

foundayo: {
    id: 'foundayo',
    nameHtml: 'Foundayo<sup>®</sup>',
    image: 'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/Foundayo_2.5mg_tablet_trim.png?v=1779267780',
    modalImage: 'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/Foundayo_2.5mg_tablet_trim.png?v=1779267780',
    price: 'Starting at £145.00',
    doseCopy: 'Taken once daily. Pause or cancel anytime.',
    tags: [
      { variant: 'primary', label: 'NEW' },
      { variant: 'secondary', label: 'In stock' }
    ],
    status: 'in_stock',
    startingStrengthId: 'foundayo-0-8',

    strengths: [
      {
        id: 'foundayo-0-8',
        handle: 'foundayo-oral-tablet',
        label: '0.8 mg – £99.00',
        isStarting: true,
        variantId: 54484715471171,
        priceText: '£99.00/month',
        heroImage: 'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/Foundayo_2.5mg_tablet_trim.png?v=1779267780'
      },
      {
        id: 'foundayo-2-5',
        handle: 'foundayo-2-5mg-tablet-30',
        label: '2.5 mg – £129.00',
        isStarting: false,
        variantId: 54492887318851,
        priceText: '£129.00/month',
        heroImage: 'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/Foundayo_2.5mg_tablet_trim.png?v=1779267780'
      },
      {
        id: 'foundayo-5-5',
        handle: 'foundayo-5-5mg-tablet-30',
        label: '5.5 mg – £139.00',
        isStarting: false,
        variantId: 54492899934531,
        priceText: '£139.00/month',
        heroImage: 'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/Foundayo_2.5mg_tablet_trim.png?v=1779267780'
      },
      {
        id: 'foundayo-9',
        handle: 'foundayo-9mg-tablet-30',
        label: '9 mg – £149.00',
        isStarting: false,
        variantId: 54492902981955,
        priceText: '£149.00/month',
        heroImage: 'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/Foundayo_2.5mg_tablet_trim.png?v=1779267780'
      },
      {
        id: 'foundayo-14-5',
        handle: 'foundayo-14-5mg-tablet-30',
        label: '14.5 mg – £169.00',
        isStarting: false,
        variantId: 54492903211331,
        priceText: '£169.00/month',
        heroImage: 'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/Foundayo_2.5mg_tablet_trim.png?v=1779267780'
      },
      {
        id: 'foundayo-17-2',
        handle: 'foundayo-17-2mg-tablet-30',
        label: '17.2 mg – £179.00',
        isStarting: false,
        variantId: 54492903670083,
        priceText: '£179.00/month',
        heroImage: 'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/Foundayo_2.5mg_tablet_trim.png?v=1779267780'
      }
    ],

    accordions: [
      { title: 'How it works', content: 'Foundayo works by mimicking a hormone that targets areas of the brain that regulate appetite and food intake.' },
      { title: 'Dose schedule', content: 'Taken once daily as a tablet at the same time each day.' },
      { title: 'How to take', content: 'Swallow the tablet whole with water, with or without food, at the same time each day.' },
      { title: 'Potential common side effects', content: 'Nausea, diarrhoea, constipation, stomach (abdominal) pain.' },
      { title: 'Important safety information', content: 'Do not use if you have a personal or family history of Medullary Thyroid Carcinoma (MTC).' }
    ]
  },

  orlos: {
    id: 'orlos',
    nameHtml: 'Orlos<sup>®</sup>',
    image: 'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/15_378d3ef1-6dd9-4720-a602-bc82782417eb.png?v=1768390296',
    modalImage: 'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/cheap_orlistat_weight_loss_pill.png?v=1769091261',
    price: '£39.99/month',
    doseCopy: 'Taken with main meals that contain fat.',
    tags: [
      { variant: 'danger', label: 'Out of stock' }
    ],
    status: 'out_of_stock',
    startingStrengthId: 'orlos-60',
    strengths: [
      {
        id: 'orlos-60',
        handle: 'orlos',
        label: '60 mg – £39.99',
        isStarting: true,
        variantId: 48311256121667,
        priceText: '£39.99/month',
        heroImage: 'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/15_378d3ef1-6dd9-4720-a602-bc82782417eb.png?v=1768390296'
      }
    ],
    accordions: [
      { title: 'How it works', content: 'Orlos works by blocking about 25% of the fat you eat from being digested.' },
      { title: 'Dose schedule', content: 'Taken orally three times a day with meals.' },
      { title: 'How to take', content: 'Swallow whole with water.' },
      { title: 'Potential common side effects', content: 'Wind (flatulence) with or without oily spotting, sudden bowel motions, soft stools.' },
      { title: 'Important safety information', content: 'Do not take if you have chronic malabsorption syndrome or cholestasis.' }
    ]
  }
};

    // Global quiz button styling
    const QUIZ_BUTTON_BG_IMAGE = 'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/Trim_vertical_1.png?v=1766336628';
    const QUIZ_BUTTON_TEXT_COLOR = '#ffffff';

    // ---------- STYLE CONFIG FROM THEME ----------
    let STEP_STYLES_BY_ID = {};
    const styleConfigEl = document.getElementById('quiz-style-config');

    // Apply same background image + white text to intro button
    if (introButton) {
      introButton.style.backgroundImage = `url('${QUIZ_BUTTON_BG_IMAGE}')`;
      introButton.style.backgroundSize = 'cover';
      introButton.style.backgroundPosition = 'center';
      introButton.style.backgroundRepeat = 'no-repeat';
      introButton.style.color = QUIZ_BUTTON_TEXT_COLOR;
      introButton.style.border = 'none';
    }

    if (styleConfigEl) {
      try {
        const cfg = JSON.parse(styleConfigEl.textContent || '{}');
        const arr = Array.isArray(cfg.steps) ? cfg.steps : [];
        STEP_STYLES_BY_ID = arr.reduce((acc, item) => {
          if (item && item.id) acc[item.id] = item;
          return acc;
        }, {});
      } catch (e) {
        console.warn('Failed to parse quiz-style-config JSON', e);
      }
    }


    const QUIZ_STEPS_BY_CATEGORY = {
      weight: [
        { id: 'weight.height_weight', type: 'height_weight', text: 'What is your height & weight?', required: true },
        { id: 'weight.journey', type: 'journey', text: 'Your estimated journey' },

        {
          id: 'weight.reasons',
          type: 'choice',
          text: 'What are your main reasons for wanting to lose weight?',
          subtext: 'Tick all that apply',
          multi: true,
          required: true,
          options: [
            { label: 'Feeling and looking healthier', value: 'feeling_looking_healthier' },
            { label: 'Return to former weight', value: 'return_former_weight' },
            { label: 'Improving mood, mental health', value: 'improving_mood_mental_health' },
            { label: 'Avoid health risks', value: 'avoid_health_risks' },
            { label: 'Just exploring', value: 'just_exploring' }
          ]
        },

        {
          id: 'weight.past_methods',
          type: 'choice',
          text: 'What have you done in the past to lose weight?',
          subtext: 'Tick all that apply',
          multi: true,
          required: true,
          options: [
            { label: 'Changing diet', value: 'changing_diet' },
            { label: 'Exercise', value: 'exercise' },
            { label: 'Medication', value: 'medication' },
            { label: 'Professional help', value: 'professional_help' },
            { label: 'First time', value: 'first_time' }
          ]
        }
        ,
{
  id: 'weight.info_feel_better',
  type: 'feel_info',
  text: 'At Trim, we know that how you feel matters just as much as what you see on the scale.',
  subtext: '92% of customers feel healthier overall since starting weight loss treatment plans through trim.*',
  buttonLabel: 'Continue'
},
{
  id: 'weight.email',
  type: 'email',
  text: 'Let’s help you hit your weight loss goals',
  required: true,
  termsTextHtml: 'I agree to the <a href="/pages/terms-conditions">terms and conditions</a>, <a href="/pages/terms-of-sale">terms of sale</a> and <a href="/pages/privacy-policy">privacy policy</a>.'
},
{
  id: 'weight.sex_at_birth',
  type: 'single',
  text: 'What was your sex assigned at birth?',
  required: true,
  options: [
    { label: 'Male', value: 'male' },
    { label: 'Female', value: 'female' }
  ]
},
{
  id: 'weight.current_situation',
  type: 'single',
  text: 'What is your current situation?',
  required: true,
  options: [
    { label: "I am trying for a baby, but I'm not pregnant yet", value: 'trying_for_baby_not_pregnant' },
    { label: 'I am breastfeeding', value: 'breastfeeding' },
    { label: 'I am pregnant', value: 'pregnant' },
    { label: 'None of these apply to me', value: 'none_apply' }
  ]
},
{
  id: 'weight.ethnicity',
  type: 'single_other',
  text: 'How would you describe your ethnicity?',
  subtext: "What's considered a healthy weight can differ by ethnic background. Share yours so we can provide the right care.",
  required: true,
  options: [
    { label: 'White or Caucasian', value: 'white_caucasian' },
    { label: 'Asian, Asian British, South Asian', value: 'asian' },
    { label: 'Black, Black British, Caribbean or African', value: 'black' },
    { label: 'Middle Eastern', value: 'middle_eastern' },
    { label: 'Other', value: 'other' },
    { label: 'I prefer not to answer', value: 'prefer_not_to_answer' }
  ]
},
{
  id: 'weight.info_medical_history',
  type: 'center_info',
  text: 'Let’s learn more about your medical history.',
  subtext: 'This will help us determine treatment eligibility and personalise your plan.',
  buttonLabel: 'Continue'
},

{
  id: 'weight.using_medication',
  type: 'using_medication_gated',
  text: 'Are you using weight loss medication?',
  required: true,
  options: [
    { label: 'Yes', value: 'yes' },
    { label: 'No', value: 'no' }
  ],
  skipStepIdIfNo: 'weight.which_medication'
},
{
  id: 'weight.which_medication',
  type: 'single_other',
  text: 'Which weight loss medication are you taking?',
  required: true,
  options: [
    { label: 'Mounjaro', value: 'mounjaro' },
    { label: 'Wegovy', value: 'wegovy' },
    { label: 'Ozempic', value: 'ozempic' },
    { label: 'Saxenda', value: 'saxenda' },
    { label: 'Orlistat', value: 'orlistat' },
    { label: 'Other', value: 'other' }
  ]
},

{
  id: 'weight.other_conditions',
  type: 'multi_none_only',
  text: 'Do you have, or have you ever had, any of the following conditions?',
  subtext: 'Please select all that apply.',
  required: true,
  options: [
    { label: 'Type 1 Diabetes, Diabetic retinopathy/diabetic eye disease', value: 'type1_diabetes' },
    { label: 'Moderate to severe chronic kidney disease', value: 'ckd' },
    { label: 'Severe liver impairment', value: 'liver' },
    { label: 'Moderate to severe heart failure', value: 'heart_failure' },
    { label: 'Pancreatitis', value: 'pancreatitis' },
    { label: 'Multiple endocrine neoplasia type 2 (MEN 2)', value: 'men2' },
    { label: 'Currently being treated for cancer', value: 'cancer_treatment' },
    { label: 'Medullary thyroid cancer (MTC) *Personal or family history', value: 'mtc' },
    { label: 'Gallbladder problems or Gallstones', value: 'gallbladder' },
    { label: 'Inflammatory bowel disease', value: 'ibd' },
    { label: 'Gastroparesis', value: 'gastroparesis' },
    { label: 'Previous stroke', value: 'stroke' },
    { label: 'Tachycardia (fast heart rate)', value: 'tachycardia' },
    { label: 'Bariatric surgery (last 2 years)', value: 'bariatric' },
    { label: 'Epilepsy', value: 'epilepsy' },
    { label: 'Organ transplant', value: 'organ_transplant' },
    { label: 'None of the above', value: 'none_of_the_above' }
  ]
},

{
  id: 'weight.eating_disorder',
  type: 'single_block_yes',
  text: 'Have you ever had an eating disorder?',
  required: true,
  options: [
    { label: 'Yes', value: 'yes' },
    { label: 'No', value: 'no' }
  ]
},

{
  id: 'weight.other_medical',
  type: 'yes_no_details',
  text: 'Do you have any other medical conditions or illnesses?',
  required: true
},

{
  id: 'weight.regular_meds',
  type: 'multi_block_values',
  text: 'Do you take any regular medications?',
  subtext: 'Tick all that apply',
  required: true,
  blockedValues: ['metformin','sglt2','insulin','sulfonylureas'],
  options: [
    { label: 'Metformin', value: 'metformin' },
    { label: 'SGLT-2 (Empagliflozin, Dapagliflozin)', value: 'sglt2' },
    { label: 'Insulin', value: 'insulin' },
    { label: 'Sulfonylureas (e.g. Gliclazide, Glimepiride)', value: 'sulfonylureas' },
    { label: 'Levothyroxine', value: 'levothyroxine' },
    { label: 'Anticoagulants (e.g. warfarin, apixaban, rivaroxaban, dabigatran, edoxaban)', value: 'anticoagulants' },
    { label: 'Other medication not listed', value: 'other_medication_not_listed' },
    { label: 'I take no regular medications', value: 'none' }
  ]
},

{
  id: 'weight.allergies',
  type: 'yes_no_details',
  text: 'Are you allergic to any medicines or substances?',
  required: true
},

{
  id: 'weight.gp_details',
  type: 'gp_details',
  text: 'Can you share your GP’s details?',
  subtext: 'Search for your GP by entering your postcode.'
},

{
  id: 'weight.dob',
  type: 'dob_confirm',
  text: 'One final thing...',
  required: true
},
      ]
    };

    // ---------- STATE ----------
    const QUIZ_ANSWERS = {};
    let currentStepIndex = 0;

    const HEIGHT_WEIGHT_STATE = {
      system: 'metric',
      metric: { height_cm: '', weight_kg: '', goal_kg: '' },
      imperial: { h_ft: '', h_in: '', w_st: '', w_lbs: '', g_st: '', g_lbs: '' }
    };
  let resultScrollCleanup = null;
    // ---------- HELPERS ----------
function getCookie(name) {
  const m = document.cookie.match(
    '(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'
  );
  return m ? decodeURIComponent(m[1]) : null;
}
 
function hasTrim30Discount() {
  // Look for "TRIM30" in any cookie value
  return /TRIM30/i.test(document.cookie || '');
}

function parseMonthlyPrice(priceText) {
  // "£195/month" or "£195.00/month" → 195 / 195.00
  const match = String(priceText).match(/([\d.,]+)/);
  return match ? parseFloat(match[1].replace(/,/g, '')) : 0;
}

function formatMonthlyPrice(amount) {
  // 165 → "£165.00/month"
  return '£' + amount.toFixed(2) + '/month';
}

// Live Shopify stock check: returns { variantId: true/false } or null on failure
async function fetchProductAvailability(handle) {
  if (!handle) return null;
  try {
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) return null;
    const data = await res.json();
    const map = {};
    (data.variants || []).forEach((v) => { map[v.id] = !!v.available; });
    return map;
  } catch (e) {
    console.warn('Availability check failed for', handle, e);
    return null;
  }
}
function scrollQuizToTop() {
  const target = root.closest('.xo-quiz-shell') || root;
  const rect = target.getBoundingClientRect();
  const top = window.pageYOffset + rect.top - 16; // small top margin
  window.scrollTo({ top, behavior: 'smooth' });
}
    function getSteps() {
      return QUIZ_STEPS_BY_CATEGORY[QUIZ_CATEGORY] || [];
    }

    function setProgressPercent(percent) {
      percent = Math.max(0, Math.min(Number(percent) || 0, 100));
      if (progressText) progressText.textContent = `${percent}%`;
      if (progressBarFill) progressBarFill.style.width = `${percent}%`;
    }

    function updateProgress() {
      const mapped = WEIGHT_STEP_PROGRESS[currentStepIndex];
      setProgressPercent(Number.isFinite(mapped) ? mapped : 8);
    }

    function recordAnswer(questionId, questionText, value) {
      QUIZ_ANSWERS[questionId] = { text: questionText, value };
    }

function createButton(label) {
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'xo-quiz-button';
  btn.innerHTML =
    `<span>${label}</span>` +
    `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
          viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          aria-hidden="true" style="flex-shrink:0;">
        <path d="M5 12h14"></path>
        <path d="m12 5 7 7-7 7"></path>
      </svg>`;

  // Force shared background image & white text on all quiz buttons
  btn.style.backgroundImage = `url('${QUIZ_BUTTON_BG_IMAGE}')`;
  btn.style.backgroundSize = 'cover';
  btn.style.backgroundPosition = 'center';
  btn.style.backgroundRepeat = 'no-repeat';
  btn.style.color = QUIZ_BUTTON_TEXT_COLOR;
  btn.style.border = 'none';
  btn.style.display = 'flex';
  btn.style.alignItems = 'center';
  btn.style.justifyContent = 'center';
  btn.style.gap = '8px';

  return btn;
}


       function applyStepStyles(stepId, container) {
      const cfg = STEP_STYLES_BY_ID[stepId];
      if (!cfg) return;

      // Background image on the whole step container
      if (cfg.background_image) {
        container.style.backgroundImage = `url(${cfg.background_image})`;
        container.style.backgroundSize = 'cover';
        container.style.backgroundPosition = 'center';
      }

      // Heading and subheading colours
      const heading = container.querySelector('h2');
      if (heading && cfg.heading_color) {
        heading.style.color = cfg.heading_color;
      }

      const sub = container.querySelector('p');
      if (sub && cfg.subheading_color) {
        sub.style.color = cfg.subheading_color;
      }

      // Borders on card elements
      if (cfg.border_color) {
        container
          .querySelectorAll('.quiz-info-card, .gpCard, .journey__card')
          .forEach((el) => {
            el.style.borderColor = cfg.border_color;
          });
      }

      // First primary button in the step
      const primaryBtn = container.querySelector('.xo-quiz-button');
      if (primaryBtn) {
        if (cfg.button_bg) primaryBtn.style.backgroundColor = cfg.button_bg;
        if (cfg.button_text) primaryBtn.style.color = cfg.button_text;
      }
    }

 function goToNextStep() {
  const steps = getSteps();
  if (currentStepIndex < steps.length - 1) {
    currentStepIndex += 1;
    renderCurrentStep();
    scrollQuizToTop();
  } else {
    onQuizComplete(); // show treatment result instead of static "Done"
    scrollQuizToTop();
  }
}

    
// ---------- RENDER WRAPPER + SLIDE ----------
function renderCurrentStep() {
  const steps = getSteps();
  const step = steps[currentStepIndex];
  if (!step) return;

  const existingWa = document.getElementById('quiz-wa-bubble');
if (existingWa) existingWa.remove();

  // On normal quiz steps, hide the theme header and remove "result" class
  if (headerSection) {
    headerSection.style.display = 'none';
  }
  const quizShell = root.closest('.xo-quiz-shell');
  if (quizShell) {
    quizShell.classList.remove('xo-quiz-shell--result');
  }

  root.innerHTML = '';

  const slide = document.createElement('div');
  slide.className = 'quiz-slide quiz-slide--enter';
  root.appendChild(slide);
  requestAnimationFrame(() => slide.classList.add('quiz-slide--enter-active'));

  const container = document.createElement('div');
  container.className = 'quiz-step';
  slide.appendChild(container);

  if (step.type === 'height_weight') {
    renderHeightWeightStep(step, container);
    applyStepStyles(step.id, container);
    updateProgress();
    return;
  }

  if (step.type === 'journey') {
    renderJourneyStep(step, container);
    applyStepStyles(step.id, container);
    updateProgress();
    return;
  }

  if (step.type === 'choice') {
    renderChoiceStep(step, container);
    applyStepStyles(step.id, container);
    updateProgress();
    return;
  }

  if (step.type === 'email') {
    renderEmailStep(step, container);
    applyStepStyles(step.id, container);
    updateProgress();
    return;
  }

  if (step.type === 'single') {
    renderSingleChoiceStep(step, container);
    applyStepStyles(step.id, container);
    updateProgress();
    return;
  }

  if (step.type === 'single_other') {
    renderSingleOtherStep(step, container);
    applyStepStyles(step.id, container);
    updateProgress();
    return;
  }

if (step.type === 'single_skip') {
    renderSingleSkipStep(step, container);
    applyStepStyles(step.id, container);
    updateProgress();
    return;
  }

  if (step.type === 'using_medication_gated') {
    renderUsingMedicationGatedStep(step, container);
    applyStepStyles(step.id, container);
    updateProgress();
    return;
  }

  if (step.type === 'multi_none_only') {
    renderMultiNoneOnlyStep(step, container);
    applyStepStyles(step.id, container);
    updateProgress();
    return;
  }

  if (step.type === 'single_block_yes') {
    renderSingleBlockYesStep(step, container);
    applyStepStyles(step.id, container);
    updateProgress();
    return;
  }

  if (step.type === 'yes_no_details') {
    renderYesNoDetailsStep(step, container);
    applyStepStyles(step.id, container);
    updateProgress();
    return;
  }

  if (step.type === 'multi_block_values') {
    renderMultiBlockValuesStep(step, container);
    applyStepStyles(step.id, container);
    updateProgress();
    return;
  }

  if (step.type === 'feel_info') {
    renderFeelInfoStep(step, container);
    applyStepStyles(step.id, container);
    updateProgress();
    return;
  }

  if (step.type === 'center_info') {
    renderCenterInfoStep(step, container);
    applyStepStyles(step.id, container);
    updateProgress();
    return;
  }

  if (step.type === 'gp_details') {
    try {
      renderGpDetailsStep(step, container);
    } catch (e) {
      container.innerHTML = `
        <div class="quiz-info-card" style="max-width:720px;margin:0 auto;">
          <strong>Renderer error</strong>
          <p style="margin:8px 0 0;">
            Step <b>${step.id}</b> failed to render.
          </p>
        </div>
      `;
      console.error('Render failed for', step.id, e);
    }
    applyStepStyles(step.id, container);
    updateProgress();
    return;
  }

  if (step.type === 'dob_confirm') {
    renderDobConfirmStep(step, container);
    applyStepStyles(step.id, container);
    updateProgress();
    return;
  }

  container.innerHTML = `
    <div class="quiz-info-card" style="max-width:720px;margin:0 auto;">
      <strong>Missing renderer</strong>
      <p style="margin:8px 0 0;">
        Step <b>${step.id}</b> has type <b>${step.type}</b> but no renderer is registered yet.
      </p>
    </div>
  `;
  updateProgress();
}

    // ---------- HEIGHT & WEIGHT ----------
    function renderHeightWeightStep(step, container) {
      const title = document.createElement('h2');
      title.textContent = step.text;
      container.appendChild(title);

      const toggle = document.createElement('div');
      toggle.className = 'quiz-toggle';

      const metricBtn = document.createElement('button');
      metricBtn.type = 'button';
      metricBtn.textContent = 'Metric';
      metricBtn.className = 'quiz-toggle__option';

      const imperialBtn = document.createElement('button');
      imperialBtn.type = 'button';
      imperialBtn.textContent = 'Imperial';
      imperialBtn.className = 'quiz-toggle__option';

      function updateToggleActive() {
        const isMetric = HEIGHT_WEIGHT_STATE.system === 'metric';
        metricBtn.classList.toggle('quiz-toggle__option--active', isMetric);
        imperialBtn.classList.toggle('quiz-toggle__option--active', !isMetric);
      }

      metricBtn.addEventListener('click', () => {
        HEIGHT_WEIGHT_STATE.system = 'metric';
        renderCurrentStep();
      });

      imperialBtn.addEventListener('click', () => {
        HEIGHT_WEIGHT_STATE.system = 'imperial';
        renderCurrentStep();
      });

      updateToggleActive();
      toggle.appendChild(metricBtn);
      toggle.appendChild(imperialBtn);
      container.appendChild(toggle);

      const fieldsWrapper = document.createElement('div');
      fieldsWrapper.className = 'quiz-hw-fields';
      container.appendChild(fieldsWrapper);

      if (HEIGHT_WEIGHT_STATE.system === 'metric') renderMetricHeightWeight(fieldsWrapper);
      else renderImperialHeightWeight(fieldsWrapper);

      const errorBox = document.createElement('div');
      errorBox.className = 'quiz-hw-error';
      errorBox.setAttribute('data-hw-error', 'true');
      errorBox.style.display = 'none';
      container.appendChild(errorBox);

      const infoCard = document.createElement('div');
      infoCard.className = 'quiz-info-card';
      infoCard.innerHTML =
        '<strong>Why we ask</strong>' +
        '<p>We use this to calculate your BMI. If you\'re unsure of your measurements, please take a moment to check before continuing. False or inaccurate information may lead to severe illness or harm.</p>';
      container.appendChild(infoCard);

      const btn = createButton('Continue');
      btn.style.display = 'block';
      btn.style.margin = '24px auto 0';
      btn.addEventListener('click', () => {
        const valid = validateHeightWeight(fieldsWrapper);
        if (!valid) return;
        recordAnswer(step.id, step.text, JSON.parse(JSON.stringify(HEIGHT_WEIGHT_STATE)));
        goToNextStep();
      });
      container.appendChild(btn);
    }

    function renderMetricHeightWeight(wrapper) {
      const s = HEIGHT_WEIGHT_STATE.metric;
      wrapper.innerHTML = '';
      wrapper.appendChild(createMetricRow('Height', 'cm', s.height_cm, (v) => (HEIGHT_WEIGHT_STATE.metric.height_cm = v), 'hw-m-height'));
      wrapper.appendChild(createMetricRow('Weight', 'kg', s.weight_kg, (v) => (HEIGHT_WEIGHT_STATE.metric.weight_kg = v), 'hw-m-weight'));
      wrapper.appendChild(createMetricRow('Goal Weight', 'kg', s.goal_kg, (v) => (HEIGHT_WEIGHT_STATE.metric.goal_kg = v), 'hw-m-goal'));
    }

    function createMetricRow(labelText, unit, value, onChange, id) {
      const row = document.createElement('div');
      row.className = 'quiz-input-row';

      const label = document.createElement('label');
      label.className = 'quiz-input-label';
      label.textContent = labelText;
      row.appendChild(label);

      const wrap = document.createElement('div');
      wrap.className = 'quiz-input-wrap';
      wrap.dataset.fieldId = id;

      const input = document.createElement('input');
      input.type = 'number';
      input.className = 'quiz-input';
      input.value = value || '';

      input.addEventListener('input', () => {
        const v = input.value;
        onChange(v);
        if (v.trim()) wrap.classList.remove('quiz-input-error');
        else wrap.classList.add('quiz-input-error');
      });

      wrap.appendChild(input);

      const unitSpan = document.createElement('span');
      unitSpan.className = 'quiz-input-unit';
      unitSpan.textContent = unit;
      wrap.appendChild(unitSpan);

      row.appendChild(wrap);
      return row;
    }

    function renderImperialHeightWeight(wrapper) {
      const s = HEIGHT_WEIGHT_STATE.imperial;
      wrapper.innerHTML = '';

      wrapper.appendChild(createImperialRowTwo('Height', 'ft', 'in', s.h_ft, s.h_in,
        (v) => (HEIGHT_WEIGHT_STATE.imperial.h_ft = v),
        (v) => (HEIGHT_WEIGHT_STATE.imperial.h_in = v),
        'hw-i-hft', 'hw-i-hin'
      ));

      wrapper.appendChild(createImperialRowTwo('Weight', 'st', 'lbs', s.w_st, s.w_lbs,
        (v) => (HEIGHT_WEIGHT_STATE.imperial.w_st = v),
        (v) => (HEIGHT_WEIGHT_STATE.imperial.w_lbs = v),
        'hw-i-wst', 'hw-i-wlbs'
      ));

      wrapper.appendChild(createImperialRowTwo('Goal Weight', 'st', 'lbs', s.g_st, s.g_lbs,
        (v) => (HEIGHT_WEIGHT_STATE.imperial.g_st = v),
        (v) => (HEIGHT_WEIGHT_STATE.imperial.g_lbs = v),
        'hw-i-gst', 'hw-i-glbs'
      ));
    }

    function createImperialRowTwo(labelText, unitLeft, unitRight, valueLeft, valueRight, onChangeLeft, onChangeRight, idLeft, idRight) {
      const row = document.createElement('div');
      row.className = 'quiz-input-row';

      const label = document.createElement('label');
      label.className = 'quiz-input-label';
      label.textContent = labelText;
      row.appendChild(label);

      const twoWrap = document.createElement('div');
      twoWrap.className = 'quiz-input-row--two';

      twoWrap.appendChild(createImperialField(unitLeft, valueLeft, onChangeLeft, idLeft));
      twoWrap.appendChild(createImperialField(unitRight, valueRight, onChangeRight, idRight));

      row.appendChild(twoWrap);
      return row;
    }

    function createImperialField(unit, value, onChange, id) {
      const wrap = document.createElement('div');
      wrap.className = 'quiz-input-wrap';
      wrap.dataset.fieldId = id;

      const input = document.createElement('input');
      input.type = 'number';
      input.className = 'quiz-input';
      input.value = value || '';

      input.addEventListener('input', () => {
        const v = input.value;
        onChange(v);
        if (v.trim()) wrap.classList.remove('quiz-input-error');
        else wrap.classList.add('quiz-input-error');
      });

      wrap.appendChild(input);

      const unitSpan = document.createElement('span');
      unitSpan.className = 'quiz-input-unit';
      unitSpan.textContent = unit;
      wrap.appendChild(unitSpan);

      return wrap;
    }

   function validateHeightWeight(wrapper) {
  wrapper.querySelectorAll('[data-field-id]').forEach((el) => el.classList.remove('quiz-input-error'));

  const container = wrapper.parentElement;
  const errorBox = container.querySelector('[data-hw-error]');
  if (errorBox) {
    errorBox.style.display = 'none';
    errorBox.innerHTML = '';
  }

  let hasEmpty = false;
  wrapper.querySelectorAll('input[type="number"]').forEach((input) => {
    if (!input.value.trim()) {
      const w = input.closest('[data-field-id]');
      if (w) w.classList.add('quiz-input-error');
      hasEmpty = true;
    }
  });
  if (hasEmpty) return false;

  let heightCm = 0;
  let weightKg = 0;

  if (HEIGHT_WEIGHT_STATE.system === 'metric') {
    heightCm = parseFloat(HEIGHT_WEIGHT_STATE.metric.height_cm) || 0;
    weightKg = parseFloat(HEIGHT_WEIGHT_STATE.metric.weight_kg) || 0;
  } else {
    const ft = parseFloat(HEIGHT_WEIGHT_STATE.imperial.h_ft) || 0;
    const inch = parseFloat(HEIGHT_WEIGHT_STATE.imperial.h_in) || 0;
    const st = parseFloat(HEIGHT_WEIGHT_STATE.imperial.w_st) || 0;
    const lbs = parseFloat(HEIGHT_WEIGHT_STATE.imperial.w_lbs) || 0;

    heightCm = (ft * 12 + inch) * 2.54;
    weightKg = st * 6.35029318 + lbs * 0.45359237;
  }

  function showError(msg) {
    if (!errorBox) return;
    errorBox.innerHTML = `
      <div class="quiz-hw-error__icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
             viewBox="0 0 24 24" fill="none" stroke="currentColor"
             stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
             aria-hidden="true">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" x2="12" y1="8" y2="12"></line>
          <line x1="12" x2="12.01" y1="16" y2="16"></line>
        </svg>
      </div>
      <div class="quiz-hw-error__text">${msg}</div>
    `;
    errorBox.style.display = 'flex';
  }

  // Existing hard min/max checks
  if (heightCm < 120 || heightCm > 240) {
    showError('Please enter a valid height between 120 cm and 240 cm.');
    return false;
  }

  if (weightKg < 40 || weightKg > 450) {
    showError('Please enter a valid weight between 40 kg and 450 kg.');
    return false;
  }

  const heightM = heightCm / 100;
  const bmi = heightM > 0 ? weightKg / (heightM * heightM) : 0;

  if (bmi < 22) {
    showError('Based on your current answer, we cannot offer you medication for this condition.');
    return false;
  }

  return true;
}


    // ---------- JOURNEY (use your current working journey function) ----------
    function computeJourneyMetrics(forProductId) {
      const hwAnswer = QUIZ_ANSWERS['weight.height_weight'];
      if (!hwAnswer || !hwAnswer.value) return null;

      const hw = hwAnswer.value;
      const system = hw.system || 'metric';

      let heightCm = 0;
      let weightKg = 0;

      if (system === 'metric') {
        const m = hw.metric || {};
        heightCm = parseFloat(m.height_cm) || 0;
        weightKg = parseFloat(m.weight_kg) || 0;
      } else {
        const im = hw.imperial || {};
        const ft = parseFloat(im.h_ft) || 0;
        const inch = parseFloat(im.h_in) || 0;
        const st = parseFloat(im.w_st) || 0;
        const lbs = parseFloat(im.w_lbs) || 0;

        heightCm = (ft * 12 + inch) * 2.54;
        weightKg = st * 6.35029318 + lbs * 0.45359237;
      }

      const heightM = heightCm / 100;
      const bmi = heightM > 0 ? weightKg / (heightM * heightM) : 0;

    const LOSS_BY_PRODUCT = {
  mounjaro: 22.5,
  wegovy: 15,
  'wegovy-injection': 15,
  'wegovy-pill': 14,
  orlos: 5
};

const POTENTIAL_LOSS_PCT = LOSS_BY_PRODUCT[forProductId] ?? 22.5;
      const endWeightKg = weightKg * (1 - POTENTIAL_LOSS_PCT / 100);
      const lossKg = weightKg - endWeightKg;

      return { system, bmi, potentialLossPct: POTENTIAL_LOSS_PCT, weightKg, endWeightKg, lossKg };
    }

    function getBmiFromAnswers() {
  const hwAnswer = QUIZ_ANSWERS['weight.height_weight'];
  if (!hwAnswer || !hwAnswer.value) return null;

  const hw = hwAnswer.value;
  const system = hw.system || 'metric';
  let heightCm = 0;
  let weightKg = 0;

  if (system === 'metric') {
    const m = hw.metric || {};
    heightCm = parseFloat(m.height_cm) || 0;
    weightKg = parseFloat(m.weight_kg) || 0;
  } else {
    const im = hw.imperial || {};
    const ft = parseFloat(im.h_ft) || 0;
    const inch = parseFloat(im.h_in) || 0;
    const st = parseFloat(im.w_st) || 0;
    const lbs = parseFloat(im.w_lbs) || 0;
    heightCm = (ft * 12 + inch) * 2.54;
    weightKg = st * 6.35029318 + lbs * 0.45359237;
  }

  const heightM = heightCm / 100;
  return heightM > 0 ? weightKg / (heightM * heightM) : null;
}

    function renderJourneyStep(step, container) {
      const which = QUIZ_ANSWERS['weight.which_medication'];
const chosen = which && typeof which.value === 'string' ? which.value : null;
const metrics = computeJourneyMetrics(chosen);
      const bmiText = metrics ? metrics.bmi.toFixed(1) : '--';
      const lossPctText = metrics ? `${metrics.potentialLossPct.toFixed(1)}%` : '--';
      const currentText = metrics ? `${Math.round(metrics.weightKg)} kg` : '--';
      const endText = metrics ? `${Math.round(metrics.endWeightKg)} kg` : '--';
      const lossText = metrics ? `${Math.round(metrics.lossKg)} kg` : '--';

      container.innerHTML = `
        <div class="journey">
          <h2 class="journey__title">${step.text || 'Your estimated journey'}</h2>

          <div class="journey__metrics">
            <div class="journey__metric">
              <div class="journey__metricLabel">Current BMI</div>
              <div class="journey__metricValue1">${bmiText}</div>
            </div>
            <div class="journey__metric">
              <div class="journey__metricLabel">Potential Loss</div>
              <div class="journey__metricValue journey__metricValue--accent">${lossPctText}</div>
            </div>
          </div>

          <div class="journey__card">
            <div class="journey__cardTop">
              <div class="journey__smallLabel">Current weight</div>
              <div class="journey__bigValue1">${currentText}</div>
            </div>

            <div class="journey__graphWrap">
              <svg class="journey__svg" viewBox="0 0 542 286" preserveAspectRatio="none" aria-hidden="true">
                <defs>
                  <clipPath id="journeyClip">
                    <rect x="0" y="0" width="0" height="286" data-journey-clip></rect>
                  </clipPath>
                  <linearGradient id="journeyGradient" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stop-color="#A890FE" stop-opacity="0.7"></stop>
                    <stop offset="95%" stop-color="#A890FE" stop-opacity="0"></stop>
                  </linearGradient>
                </defs>

                <g clip-path="url(#journeyClip)">
                  <path stroke-width="4" fill="url(#journeyGradient)" stroke="none"
                    d="M0,76.246C15.056,84.105,30.111,91.963,45.167,98.881C60.222,105.799,75.278,112.033,90.333,117.754C105.389,123.474,120.444,128.568,135.5,133.205C150.556,137.843,165.611,141.91,180.667,145.578C195.722,149.246,210.778,152.401,225.833,155.214C240.889,158.026,255.944,160.383,271,162.455C286.056,164.526,301.111,166.199,316.167,167.643C331.222,169.088,346.278,170.19,361.333,171.121C376.389,172.052,391.444,172.699,406.5,173.231C421.556,173.763,436.611,174.067,451.667,174.314C466.722,174.561,481.778,174.675,496.833,174.713C511.889,174.751,526.944,174.761,542,174.77L542,286L0,286Z"></path>
                  <path stroke="#A890FE" stroke-width="4" fill="none" stroke-linecap="round"
                    d="M0,76.246C15.056,84.105,30.111,91.963,45.167,98.881C60.222,105.799,75.278,112.033,90.333,117.754C105.389,123.474,120.444,128.568,135.5,133.205C150.556,137.843,165.611,141.91,180.667,145.578C195.722,149.246,210.778,152.401,225.833,155.214C240.889,158.026,255.944,160.383,271,162.455C286.056,164.526,301.111,166.199,316.167,167.643C331.222,169.088,346.278,170.19,361.333,171.121C376.389,172.052,391.444,172.699,406.5,173.231C421.556,173.763,436.611,174.067,451.667,174.314C466.722,174.561,481.778,174.675,496.833,174.713C511.889,174.751,526.944,174.761,542,174.77"></path>
                </g>
              </svg>

              <div class="journey__marker" data-journey-marker>
                <span class="journey__lossPill">↓ ${lossText}</span>
                <span class="journey__dot"></span>
                <span class="journey__line"></span>
              </div>
            </div>

            <div class="journey__cardBottom">
              <div class="journey__smallLabel">Potential end weight</div>
              <div class="journey__bigValue">${endText}</div>
            </div>
          </div>

          <p class="journey__footnote">
  Lose up to ${metrics ? metrics.potentialLossPct.toFixed(1) : '22.5'}% body weight on GLP-1 weight loss programmes.
</p>
        </div>
      `;

      const btn = createButton('Continue');
      btn.style.display = 'block';
      btn.style.margin = '24px auto 0';
      btn.addEventListener('click', goToNextStep);
      container.appendChild(btn);

      const clipRect = container.querySelector('[data-journey-clip]');
      const marker = container.querySelector('[data-journey-marker]');
      if (!clipRect) return;

      const VIEW_W = 542;
      const duration = 1100;
      const start = performance.now();
      const easeOutCubic = (x) => 1 - Math.pow(1 - x, 3);

      if (marker) {
        marker.style.opacity = '0';
        marker.style.transform = 'translateY(-6px)';
      }

      function tick(now) {
        const rawT = Math.min((now - start) / duration, 1);
        const t = easeOutCubic(rawT);
        clipRect.setAttribute('width', String(VIEW_W * t));

        if (marker) {
          const m = Math.max(0, (rawT - 0.78) / 0.22);
          marker.style.opacity = String(m);
          marker.style.transform = `translateY(${(-6 + 6 * m).toFixed(2)}px)`;
        }

        if (rawT < 1) requestAnimationFrame(tick);
      }

      requestAnimationFrame(tick);
    }

    // ---------- CHOICE ----------
    function renderChoiceStep(step, container) {
  const h = document.createElement('h2');
  h.textContent = step.text || '';
  h.style.textAlign = 'left';
  h.style.margin = '0 0 6px';
  container.appendChild(h);

  if (step.subtext) {
    const p = document.createElement('p');
    p.textContent = step.subtext;
    p.style.textAlign = 'left';
    p.style.margin = '0 0 16px';
    p.style.color = 'rgba(43,43,43,.65)';
    p.style.fontSize = '14px';
    container.appendChild(p);
  }

  const existing = (QUIZ_ANSWERS[step.id] && QUIZ_ANSWERS[step.id].value) || [];
  const selected = new Set(Array.isArray(existing) ? existing : []);

  const list = document.createElement('div');
  list.className = 'quiz-reasons-options';
  container.appendChild(list);

  step.options.forEach((opt) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'quiz-reasons-option';
    btn.textContent = opt.label;

    if (selected.has(opt.value)) btn.classList.add('is-selected');

    btn.addEventListener('click', () => {
      if (selected.has(opt.value)) {
        selected.delete(opt.value);
        btn.classList.remove('is-selected');
      } else {
        selected.add(opt.value);
        btn.classList.add('is-selected');
      }
      recordAnswer(step.id, step.text, Array.from(selected));
      updateState();
    });

    list.appendChild(btn);
  });

  const errorBox = document.createElement('div');
  errorBox.className = 'quiz-hw-error';
  errorBox.style.display = 'none';
  errorBox.innerHTML = `
    <div class="quiz-hw-error__icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
           viewBox="0 0 24 24" fill="none" stroke="currentColor"
           stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
           aria-hidden="true">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" x2="12" y1="8" y2="12"></line>
        <line x1="12" x2="12.01" y1="16" y2="16"></line>
      </svg>
    </div>
    <div class="quiz-hw-error__text">
      <strong>Important Safety Information</strong><br>
      Based on your answer, we cannot offer you medication for this condition.
    </div>
  `;
  container.appendChild(errorBox);

  const nextBtn = createButton('Next');
  nextBtn.style.display = 'block';
  nextBtn.style.margin = '24px auto 0';
  container.appendChild(nextBtn);

  nextBtn.addEventListener('click', () => {
    const hasAny = selected.size > 0;
    const blocked = selected.has('just_exploring') || selected.has('first_time');
    if (step.required && !hasAny) return;
    if (blocked) return;
    goToNextStep();
  });

  function updateState() {
    const hasAny = selected.size > 0;
    const blocked = selected.has('just_exploring') || selected.has('first_time');
    errorBox.style.display = blocked ? 'flex' : 'none';
    nextBtn.disabled = !(hasAny && !blocked);
    nextBtn.style.opacity = nextBtn.disabled ? '0.55' : '1';
  }

  updateState();
}
function renderFeelInfoStep(step, container) {
  // You can later move these to Customizer if needed
  const heroImage =
    'https://cdn.shopify.com/s/files/1/0811/4130/1571/files/happy_woman_celebrating_weight_loss_success_outdoors-B_gSUJKL.png?v=1767954900';

  const titleText = step.text || '';
  const statText = '92%';
  const statBody =
    step.subtext ||
    'of customers feel healthier overall since starting weight loss treatment plans through XO.*';

  const footnote =
    '*Based on feedback from over 200 customers between December 2023 and December 2025.';

  container.innerHTML = `
    <div class="feel">
      <h2 class="feel__title">${escapeHtml(titleText)}</h2>

      <div class="feel__hero" role="img" aria-label="Happy customer outdoors">
        <img class="feel__heroImg" src="${heroImage}" alt="" loading="lazy">
        <div class="feel__heroOverlay"></div>

        <div class="feel__heroContent">
          <div class="feel__stat">${escapeHtml(statText)}</div>
          <div class="feel__statText">${escapeHtml(statBody)}</div>
        </div>
      </div>

      <p class="feel__footnote">${escapeHtml(footnote)}</p>
    </div>
  `;

  const btn = createButton(step.buttonLabel || 'Continue');
  btn.style.display = 'block';
  btn.style.margin = '24px auto 0';
  btn.addEventListener('click', goToNextStep);
  container.appendChild(btn);
}

// tiny helper (needed because we used template strings)
function escapeHtml(s) {
  return String(s).replace(/[&<>"']/g, (m) => ({
    "&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#039;"
  }[m]));
}

function renderEmailStep(step, container) {
  const card = document.createElement('div');
  card.className = 'emailCard';

  const title = document.createElement('h2');
  title.className = 'emailCard__title';
  title.textContent = step.text || "Let’s help you hit your weight loss goals";
  card.appendChild(title);

  // Email field
  const label = document.createElement('label');
  label.className = 'emailCard__label';
  label.textContent = 'Email address';
  card.appendChild(label);

  const inputWrap = document.createElement('div');
  inputWrap.className = 'emailCard__inputWrap';

  const input = document.createElement('input');
  input.type = 'email';
  input.className = 'emailCard__input';
  input.placeholder = '';
  input.autocomplete = 'email';

  const existing = QUIZ_ANSWERS[step.id] && QUIZ_ANSWERS[step.id].value;
  if (existing) input.value = existing;

  inputWrap.appendChild(input);
  card.appendChild(inputWrap);

  const helper = document.createElement('p');
  helper.className = 'emailCard__helper';
  helper.textContent =
    "We'll use this to create your secure account and send you a one-time sign-in link. No password required.";
  card.appendChild(helper);

  // Checkbox row
  const termsRow = document.createElement('div');
  termsRow.className = 'emailCard__terms';

  const checkbox = document.createElement('input');
  checkbox.type = 'checkbox';
  checkbox.className = 'emailCard__checkbox';
  checkbox.checked = false;

  const termsText = document.createElement('div');
  termsText.className = 'emailCard__termsText';
  termsText.innerHTML =
    step.termsTextHtml ||
    'I agree to the <a href="/pages/terms-conditions">terms and conditions</a>, pharmacy terms, <a href="/pages/terms-of-sale">terms of sale</a> and <a href="/pages/privacy-policy">privacy policy</a>';

  termsRow.appendChild(checkbox);
  termsRow.appendChild(termsText);
  card.appendChild(termsRow);

  container.appendChild(card);

  // Continue button (disabled until valid)
  const btn = createButton('Continue');
  btn.classList.add('emailCard__cta');
  btn.disabled = true;
  btn.style.opacity = '0.55';
  container.appendChild(btn);

  function isValidEmail(val) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
  }

  function updateState(showErrors) {
    const emailVal = input.value.trim();
    const okEmail = isValidEmail(emailVal);
    const okTerms = checkbox.checked;

    if (showErrors && !okEmail) inputWrap.classList.add('emailCard__inputWrap--error');
    if (okEmail) inputWrap.classList.remove('emailCard__inputWrap--error');

    if (emailVal) recordAnswer(step.id, 'Email', emailVal);

    const canContinue = okEmail && okTerms;
    btn.disabled = !canContinue;
    btn.style.opacity = canContinue ? '1' : '0.55';
  }

  input.addEventListener('input', () => updateState(false));
  input.addEventListener('blur', () => updateState(true));
  checkbox.addEventListener('change', () => updateState(false));

  btn.addEventListener('click', () => {
    updateState(true);
    if (btn.disabled) return;
    goToNextStep();
  });

  updateState(false);
}


let CURRENT_SITUATION_MODE = 'options'; // 'options' | 'safety'

function renderSingleChoiceStep(step, container) {
  const h = document.createElement('h2');
  h.textContent = step.text || '';
  h.style.textAlign = 'left';
  h.style.margin = '0 0 16px';
  container.appendChild(h);

  const optionsWrap = document.createElement('div');
  optionsWrap.className = 'quiz-reasons-options';
  container.appendChild(optionsWrap);

  const existing = QUIZ_ANSWERS[step.id] && QUIZ_ANSWERS[step.id].value;
  let selected = typeof existing === 'string' ? existing : null;

  function select(value) {
    selected = value;
    recordAnswer(step.id, step.text, value);

    // Special: sex_at_birth skip logic
    if (step.id === 'weight.sex_at_birth' && value === 'male') {
      // skip current_situation
      const steps = getSteps();
      const i = currentStepIndex;
      const next = steps[i + 1];
      if (next && next.id === 'weight.current_situation') {
        currentStepIndex = i + 2;
        renderCurrentStep();
        return;
      }
    }

    // Special: current_situation logic
    if (step.id === 'weight.current_situation') {
      if (value === 'none_apply') {
        goToNextStep();
        return;
      }
      if (value === 'breastfeeding' || value === 'pregnant') {
        showBlockedSafety();
        return;
      }
      if (value === 'trying_for_baby_not_pregnant') {
        showSafetyConfirm();
        return;
      }
    } else {
      goToNextStep();
    }
  }

  // Blocked safety card (pregnant/breastfeeding)
  const blocked = document.createElement('div');
  blocked.className = 'quiz-hw-error';
  blocked.style.display = 'none';
  blocked.innerHTML = `
    <div class="quiz-hw-error__icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
           viewBox="0 0 24 24" fill="none" stroke="currentColor"
           stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
           aria-hidden="true">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" x2="12" y1="8" y2="12"></line>
        <line x1="12" x2="12.01" y1="16" y2="16"></line>
      </svg>
    </div>
    <div class="quiz-hw-error__text">
      <strong>Important Safety Information</strong><br>
      Based on your answer, we cannot offer you medication for this condition.
    </div>
  `;
  container.appendChild(blocked);

  // Safety confirm card (trying for baby)
  const safety = document.createElement('div');
  safety.className = 'quiz-info-card';
  safety.style.display = 'none';
  safety.innerHTML = `
    <strong>For your safety:</strong>
    <p style="margin:8px 0 0; font-size:13px; line-height:1.55;">
      GLP-1 medications like Wegovy®, Mounjaro®, or Liraglutide can be harmful during pregnancy.
      If you’re planning to become pregnant, it’s important to stop Wegovy at least two months
      before trying and Mounjaro at least one month before.
    </p>
    <div style="display:flex; gap:10px; margin-top:12px; align-items:flex-start;">
      <input type="checkbox" data-safety-check style="margin-top:3px;">
      <span style="font-size:13px; color: rgba(43,43,43,.78);">
        I confirm I will inform my prescriber and stop treatment if I become pregnant,
        and I acknowledge the safety information provided.
      </span>
    </div>
  `;
  container.appendChild(safety);

  const safetyCheck = safety.querySelector('[data-safety-check]');

  const safetyContinue = createButton('Continue');
  safetyContinue.style.display = 'none';
  safetyContinue.style.margin = '24px auto 0';
  safetyContinue.disabled = true;
  safetyContinue.style.opacity = '0.55';
  container.appendChild(safetyContinue);

  safetyContinue.addEventListener('click', () => {
    if (safetyContinue.disabled) return;
    goToNextStep();
  });

  if (safetyCheck) {
    safetyCheck.addEventListener('change', () => {
      const ok = safetyCheck.checked && selected === 'trying_for_baby_not_pregnant';
      safetyContinue.disabled = !ok;
      safetyContinue.style.opacity = ok ? '1' : '0.55';
    });
  }

  function showBlockedSafety() {
    CURRENT_SITUATION_MODE = 'options';
    blocked.style.display = 'flex';
    safety.style.display = 'none';
    safetyContinue.style.display = 'none';
  }

  function showSafetyConfirm() {
    CURRENT_SITUATION_MODE = 'safety';
    blocked.style.display = 'none';
    safety.style.display = 'block';
    safetyContinue.style.display = 'block';
    if (safetyCheck) safetyCheck.checked = false;
    safetyContinue.disabled = true;
    safetyContinue.style.opacity = '0.55';
  }

  // Build buttons
  step.options.forEach((opt) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'quiz-reasons-option';
    btn.textContent = opt.label;

    if (selected === opt.value) btn.classList.add('is-selected');

    btn.addEventListener('click', () => {
      // clear selection UI
      optionsWrap.querySelectorAll('.quiz-reasons-option').forEach((b) => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');

      // reset state cards if needed
      blocked.style.display = 'none';
      safety.style.display = 'none';
      safetyContinue.style.display = 'none';

      select(opt.value);
    });

    optionsWrap.appendChild(btn);
  });

  // Restore state when coming back
  if (step.id === 'weight.current_situation' && selected === 'trying_for_baby_not_pregnant' && CURRENT_SITUATION_MODE === 'safety') {
    showSafetyConfirm();
  }
}

function renderSingleOtherStep(step, container) {
  const h = document.createElement('h2');
  h.textContent = step.text || '';
  h.style.textAlign = 'left';
  h.style.margin = '0 0 8px';
  container.appendChild(h);

  if (step.subtext) {
    const p = document.createElement('p');
    p.textContent = step.subtext;
    p.style.textAlign = 'left';
    p.style.margin = '0 0 16px';
    p.style.color = 'rgba(43,43,43,.65)';
    p.style.fontSize = '14px';
    container.appendChild(p);
  }

  const optionsWrap = document.createElement('div');
  optionsWrap.className = 'quiz-reasons-options';
  container.appendChild(optionsWrap);

  // stored can be string or {choice:'other', other_text:'...'}
  const stored = QUIZ_ANSWERS[step.id] && QUIZ_ANSWERS[step.id].value;
  let selected = null;
  let otherText = '';

  if (typeof stored === 'string') selected = stored;
  if (stored && typeof stored === 'object') {
    selected = stored.choice;
    otherText = stored.other_text || '';
  }

  const otherWrap = document.createElement('div');
  otherWrap.className = 'quiz-info-card';
  otherWrap.style.display = 'none';
  otherWrap.innerHTML = `
    <strong>Please specify</strong>
    <div style="margin-top:10px;">
      <input type="text" class="quiz-ethnicity-input" placeholder="Type here">
      <div class="quiz-ethnicity-error" style="display:none; color:#8b1d1d; font-size:13px; margin-top:8px;">
        Please tell us a bit more.
      </div>
    </div>
  `;
  container.appendChild(otherWrap);

  const otherInput = otherWrap.querySelector('.quiz-ethnicity-input');
  const otherErr = otherWrap.querySelector('.quiz-ethnicity-error');

  if (otherInput) otherInput.value = otherText;

  const nextBtn = createButton('Continue');
  nextBtn.style.display = 'none';
  nextBtn.style.margin = '24px auto 0';
  nextBtn.disabled = true;
  nextBtn.style.opacity = '0.55';
  container.appendChild(nextBtn);

  function validateOther(showErrors) {
    const val = (otherInput ? otherInput.value : '').trim();
    const ok = val.length > 0;
    nextBtn.disabled = !ok;
    nextBtn.style.opacity = ok ? '1' : '0.55';
    if (otherErr) otherErr.style.display = (!ok && showErrors) ? 'block' : 'none';
    return ok;
  }

  function choose(value) {
    selected = value;

    if (value === 'other') {
      otherWrap.style.display = 'block';
      nextBtn.style.display = 'block';
      if (otherInput) otherInput.focus();
      validateOther(false);
      return;
    }

    otherWrap.style.display = 'none';
    nextBtn.style.display = 'none';
    recordAnswer(step.id, step.text, value);
    goToNextStep();
  }

  step.options.forEach((opt) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'quiz-reasons-option';
    btn.textContent = opt.label;
    if (selected === opt.value) btn.classList.add('is-selected');

    btn.addEventListener('click', () => {
      optionsWrap.querySelectorAll('.quiz-reasons-option').forEach((b) => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');
      choose(opt.value);
    });

    optionsWrap.appendChild(btn);
  });

  if (otherInput) {
    otherInput.addEventListener('input', () => validateOther(false));
    otherInput.addEventListener('blur', () => validateOther(true));
  }

  nextBtn.addEventListener('click', () => {
    if (!validateOther(true)) return;
    const val = otherInput.value.trim();
    recordAnswer(step.id, step.text, { choice: 'other', other_text: val });
    goToNextStep();
  });

  // Restore UI if coming back on "other"
  if (selected === 'other') {
    otherWrap.style.display = 'block';
    nextBtn.style.display = 'block';
    validateOther(false);
  }
}


function renderSingleSkipStep(step, container) {
  const h = document.createElement('h2');
  h.textContent = step.text || '';
  h.style.textAlign = 'left';
  h.style.margin = '0 0 16px';
  container.appendChild(h);

  const optionsWrap = document.createElement('div');
  optionsWrap.className = 'quiz-reasons-options';
  container.appendChild(optionsWrap);

  const existing = QUIZ_ANSWERS[step.id] && QUIZ_ANSWERS[step.id].value;
  let selected = typeof existing === 'string' ? existing : null;

  step.options.forEach((opt) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'quiz-reasons-option';
    btn.textContent = opt.label;

    if (selected === opt.value) btn.classList.add('is-selected');

    btn.addEventListener('click', () => {
      // UI selected state
      optionsWrap.querySelectorAll('.quiz-reasons-option')
        .forEach((b) => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');

      selected = opt.value;
      recordAnswer(step.id, step.text, selected);

      // SKIP: if user selected the "no" option, jump over the configured step
      if (selected === 'no' && step.skipStepIdIfNo) {
        const steps = getSteps();
        const next = steps[currentStepIndex + 1];
        if (next && next.id === step.skipStepIdIfNo) {
          currentStepIndex += 2;   // jump over "which_medication"
          renderCurrentStep();
          scrollQuizToTop();
          return;
        }
      }

      // normal next step
      goToNextStep();
    });

    optionsWrap.appendChild(btn);
  });
}

function renderUsingMedicationGatedStep(step, container) {
  const h = document.createElement('h2');
  h.textContent = step.text || '';
  h.style.textAlign = 'left';
  h.style.margin = '0 0 16px';
  container.appendChild(h);

  const optionsWrap = document.createElement('div');
  optionsWrap.className = 'quiz-reasons-options';
  container.appendChild(optionsWrap);

  const existing = QUIZ_ANSWERS[step.id] && QUIZ_ANSWERS[step.id].value;
  let selected = typeof existing === 'string' ? existing : null;

  const bmi = getBmiFromAnswers();
  const requiresMedConfirmation = bmi !== null && bmi >= 22 && bmi < 27;

  const errorBox = document.createElement('div');
  errorBox.className = 'quiz-hw-error';
  errorBox.style.display = 'none';
  errorBox.innerHTML = `
    <div class="quiz-hw-error__icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
           viewBox="0 0 24 24" fill="none" stroke="currentColor"
           stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
           aria-hidden="true">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" x2="12" y1="8" y2="12"></line>
        <line x1="12" x2="12.01" y1="16" y2="16"></line>
      </svg>
    </div>
    <div class="quiz-hw-error__text">
      <strong>Important Safety Information</strong><br>
      Based on your current answer, we cannot offer you medication for this condition.
    </div>
  `;
  container.appendChild(errorBox);

  function clearSelections() {
    optionsWrap.querySelectorAll('.quiz-reasons-option').forEach((el) =>
      el.classList.remove('is-selected')
    );
  }

  function handleSelect(value, btn) {
    selected = value;
    recordAnswer(step.id, step.text, value);
    clearSelections();
    btn.classList.add('is-selected');

    if (value === 'no') {
      if (requiresMedConfirmation) {
        errorBox.style.display = 'flex';
        return;
      }
      errorBox.style.display = 'none';
      const steps = getSteps();
      const next = steps[currentStepIndex + 1];
      if (next && next.id === step.skipStepIdIfNo) {
        currentStepIndex += 2;
        renderCurrentStep();
        scrollQuizToTop();
      } else {
        goToNextStep();
      }
      return;
    }

    errorBox.style.display = 'none';
    goToNextStep();
  }

  step.options.forEach((opt) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'quiz-reasons-option';
    btn.textContent = opt.label;

    if (selected === opt.value) {
      btn.classList.add('is-selected');
      if (opt.value === 'no' && requiresMedConfirmation) {
        errorBox.style.display = 'flex';
      }
    }

    btn.addEventListener('click', () => handleSelect(opt.value, btn));
    optionsWrap.appendChild(btn);
  });
}

function renderMultiNoneOnlyStep(step, container) {
  const stored = QUIZ_ANSWERS[step.id] && QUIZ_ANSWERS[step.id].value;
  const selected = new Set(Array.isArray(stored) ? stored : []);
  const NONE = 'none_of_the_above';

  container.innerHTML = `
    <div class="scrollPick">
      <h2 class="scrollPick__title">${escapeHtml(step.text || '')}</h2>
      ${step.subtext ? `<p class="scrollPick__sub">${escapeHtml(step.subtext)}</p>` : ''}

      <div class="scrollPick__wrap">
        <div class="scrollPick__list" data-scroll-list></div>
      </div>

      <button type="button" class="scrollPick__toggle" data-scroll-toggle aria-label="Scroll">
        <span class="scrollPick__chev"></span>
      </button>

      <div class="quiz-hw-error scrollPick__error" data-block-error style="display:none;">
        <div class="quiz-hw-error__icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
               viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
               aria-hidden="true">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" x2="12" y1="8" y2="12"></line>
            <line x1="12" x2="12.01" y1="16" y2="16"></line>
          </svg>
        </div>
        <div class="quiz-hw-error__text">
          <strong>Important Safety Information</strong><br>
          Based on your answer, we cannot offer you medication for this condition.
        </div>
      </div>
    </div>
  `;

  const listEl = container.querySelector('[data-scroll-list]');
  const toggleBtn = container.querySelector('[data-scroll-toggle]');
  const scrollBox = container.querySelector('.scrollPick__list');
  const errorBox = container.querySelector('[data-block-error]');

  // Render rows
  step.options.forEach((opt) => {
    const row = document.createElement('button');
    row.type = 'button';
    row.className = 'scrollRow';
    row.dataset.value = opt.value;
    row.innerHTML = `
      <span class="scrollRow__label">${escapeHtml(opt.label)}</span>
      <span class="scrollRow__box" aria-hidden="true"></span>
    `;

    if (selected.has(opt.value)) row.classList.add('is-selected');

    row.addEventListener('click', () => {
      const v = opt.value;

      if (v === NONE) {
        selected.clear();
        selected.add(NONE);
        listEl.querySelectorAll('.scrollRow').forEach((r) => r.classList.remove('is-selected'));
        row.classList.add('is-selected');
      } else {
        selected.delete(NONE);
        const noneRow = listEl.querySelector('[data-value="none_of_the_above"]');
        if (noneRow) noneRow.classList.remove('is-selected');

        if (selected.has(v)) {
          selected.delete(v);
          row.classList.remove('is-selected');
        } else {
          selected.add(v);
          row.classList.add('is-selected');
        }
      }

      recordAnswer(step.id, step.text, Array.from(selected));
      updateState();
    });

    listEl.appendChild(row);
  });

  const nextBtn = createButton('Next');
  nextBtn.classList.add('scrollPick__cta');
  nextBtn.disabled = true;
  nextBtn.style.opacity = '0.55';
  nextBtn.addEventListener('click', () => {
    if (nextBtn.disabled) return;
    goToNextStep();
  });
  container.appendChild(nextBtn);

  function updateState() {
    const values = Array.from(selected);
    const hasAny = values.length > 0;
    const hasNonNone = values.some((v) => v !== NONE);

    const canContinue = hasAny && !hasNonNone; // only NONE selected
    nextBtn.disabled = !canContinue;
    nextBtn.style.opacity = canContinue ? '1' : '0.55';

    errorBox.style.display = hasAny && hasNonNone ? 'flex' : 'none';
  }

  // scroll toggle
  function atTop() { return scrollBox.scrollTop <= 0; }
  function updateToggle() {
    toggleBtn.classList.toggle('scrollPick__toggle--up', !atTop());
  }
  scrollBox.addEventListener('scroll', updateToggle);
  toggleBtn.addEventListener('click', () => {
    const target = atTop() ? scrollBox.scrollHeight : 0;
    scrollBox.scrollTo({ top: target, behavior: 'smooth' });
  });

  updateState();
  updateToggle();

  // Ensure at least ~6 rows are visible before scroll
  const firstRow = scrollBox.querySelector('.scrollRow');
  if (firstRow) {
    const rowHeight = firstRow.getBoundingClientRect().height || 44;
    scrollBox.style.maxHeight = (rowHeight * 5) + 'px';
  }
}

function renderSingleBlockYesStep(step, container) {
  // Same as single choice, but if yes selected -> show error and block
  const h = document.createElement('h2');
  h.textContent = step.text || '';
  h.style.textAlign = 'left';
  h.style.margin = '0 0 16px';
  container.appendChild(h);

  const optionsWrap = document.createElement('div');
  optionsWrap.className = 'quiz-reasons-options';
  container.appendChild(optionsWrap);

  const existing = QUIZ_ANSWERS[step.id] && QUIZ_ANSWERS[step.id].value;
  let selected = typeof existing === 'string' ? existing : null;

  const errorBox = document.createElement('div');
  errorBox.className = 'quiz-hw-error';
  errorBox.style.display = 'none';
  errorBox.innerHTML = `
    <div class="quiz-hw-error__icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
           viewBox="0 0 24 24" fill="none" stroke="currentColor"
           stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
           aria-hidden="true">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" x2="12" y1="8" y2="12"></line>
        <line x1="12" x2="12.01" y1="16" y2="16"></line>
      </svg>
    </div>
    <div class="quiz-hw-error__text">
      <strong>Important Safety Information</strong><br>
      Based on your answer, we cannot offer you medication for this condition.
    </div>
  `;
  container.appendChild(errorBox);

  step.options.forEach((opt) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'quiz-reasons-option';
    btn.textContent = opt.label;

    if (selected === opt.value) btn.classList.add('is-selected');

    btn.addEventListener('click', () => {
      optionsWrap.querySelectorAll('.quiz-reasons-option').forEach((b) => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');

      selected = opt.value;
      recordAnswer(step.id, step.text, selected);

      if (selected === 'yes') {
        errorBox.style.display = 'flex';
        return; // block
      }
      errorBox.style.display = 'none';
      goToNextStep();
    });

    optionsWrap.appendChild(btn);
  });

  if (selected === 'yes') errorBox.style.display = 'flex';
}

function renderYesNoDetailsStep(step, container) {
  const h = document.createElement('h2');
  h.textContent = step.text || '';
  h.style.textAlign = 'left';
  h.style.margin = '0 0 16px';
  container.appendChild(h);

  const optionsWrap = document.createElement('div');
  optionsWrap.className = 'quiz-reasons-options';
  container.appendChild(optionsWrap);

  const stored = QUIZ_ANSWERS[step.id] && QUIZ_ANSWERS[step.id].value;
  let choice = null;
  let details = '';

  if (typeof stored === 'string') choice = stored;
  if (stored && typeof stored === 'object') {
    choice = stored.choice;
    details = stored.details || '';
  }

  const detailsWrap = document.createElement('div');
  detailsWrap.className = 'quiz-info-card';
  detailsWrap.style.display = 'none';
  detailsWrap.innerHTML = `
    <strong>Please specify</strong>
    <div style="margin-top:10px;">
      <input type="text" class="quiz-ethnicity-input" placeholder="Please specify">
      <div class="quiz-ethnicity-error" style="display:none; color:#8b1d1d; font-size:13px; margin-top:8px;">
        This field is required.
      </div>
    </div>
  `;
  container.appendChild(detailsWrap);

  const input = detailsWrap.querySelector('.quiz-ethnicity-input');
  const err = detailsWrap.querySelector('.quiz-ethnicity-error');
  if (input) input.value = details;

  const nextBtn = createButton('Next');
  nextBtn.style.display = 'none';
  nextBtn.style.margin = '24px auto 0';
  nextBtn.disabled = true;
  nextBtn.style.opacity = '0.55';
  container.appendChild(nextBtn);

  function validate(showErrors) {
    const val = (input ? input.value : '').trim();
    const ok = val.length > 0;
    nextBtn.disabled = !ok;
    nextBtn.style.opacity = ok ? '1' : '0.55';
    if (err) err.style.display = (!ok && showErrors) ? 'block' : 'none';
    return ok;
  }

  function select(v) {
    choice = v;

    if (v === 'no') {
      recordAnswer(step.id, step.text, 'no');
      goToNextStep();
      return;
    }

    // yes
    detailsWrap.style.display = 'block';
    nextBtn.style.display = 'block';
    validate(false);
    if (input) input.focus();
  }

  ['yes', 'no'].forEach((v) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'quiz-reasons-option';
    btn.textContent = v === 'yes' ? 'Yes' : 'No';
    btn.dataset.value = v;

    if (choice === v) btn.classList.add('is-selected');

    btn.addEventListener('click', () => {
      optionsWrap.querySelectorAll('.quiz-reasons-option').forEach((b) => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');
      select(v);
    });

    optionsWrap.appendChild(btn);
  });

  if (input) {
    input.addEventListener('input', () => validate(false));
    input.addEventListener('blur', () => validate(true));
  }

  nextBtn.addEventListener('click', () => {
    if (!validate(true)) return;
    recordAnswer(step.id, step.text, { choice: 'yes', details: input.value.trim() });
    goToNextStep();
  });

  // restore
  if (choice === 'yes') {
    detailsWrap.style.display = 'block';
    nextBtn.style.display = 'block';
    validate(false);
  }
}

function renderMultiBlockValuesStep(step, container) {
  const stored = QUIZ_ANSWERS[step.id] && QUIZ_ANSWERS[step.id].value;
  const selected = new Set(Array.isArray(stored) ? stored : []);
  const blocked = new Set(step.blockedValues || []);

  container.innerHTML = `
    <div class="scrollPick">
      <h2 class="scrollPick__title">${escapeHtml(step.text || '')}</h2>
      ${step.subtext ? `<p class="scrollPick__sub">${escapeHtml(step.subtext)}</p>` : ''}

      <div class="scrollPick__wrap">
        <div class="scrollPick__list" data-scroll-list></div>
      </div>

      <button type="button" class="scrollPick__toggle" data-scroll-toggle aria-label="Scroll">
        <span class="scrollPick__chev"></span>
      </button>

      <div class="quiz-hw-error scrollPick__error" data-block-error style="display:none;">
        <div class="quiz-hw-error__icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
               viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
               aria-hidden="true">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" x2="12" y1="8" y2="12"></line>
            <line x1="12" x2="12.01" y1="16" y2="16"></line>
          </svg>
        </div>
        <div class="quiz-hw-error__text">
          <strong>Important Safety Information</strong><br>
          Based on your answer, we cannot offer you medication for this condition.
        </div>
      </div>
    </div>
  `;

  const listEl = container.querySelector('[data-scroll-list]');
  const toggleBtn = container.querySelector('[data-scroll-toggle]');
  const scrollBox = container.querySelector('.scrollPick__list');
  const errorBox = container.querySelector('[data-block-error]');

  step.options.forEach((opt) => {
    const row = document.createElement('button');
    row.type = 'button';
    row.className = 'scrollRow';
    row.dataset.value = opt.value;
    row.innerHTML = `
      <span class="scrollRow__label">${escapeHtml(opt.label)}</span>
      <span class="scrollRow__box" aria-hidden="true"></span>
    `;

    if (selected.has(opt.value)) row.classList.add('is-selected');

    row.addEventListener('click', () => {
      const v = opt.value;
      if (selected.has(v)) {
        selected.delete(v);
        row.classList.remove('is-selected');
      } else {
        selected.add(v);
        row.classList.add('is-selected');
      }
      recordAnswer(step.id, step.text, Array.from(selected));
      updateState();
    });

    listEl.appendChild(row);
  });

  const nextBtn = createButton('Next');
  nextBtn.classList.add('scrollPick__cta');
  nextBtn.disabled = true;
  nextBtn.style.opacity = '0.55';
  nextBtn.addEventListener('click', () => {
    if (nextBtn.disabled) return;
    goToNextStep();
  });
  container.appendChild(nextBtn);

  function updateState() {
    const values = Array.from(selected);
    const hasAny = values.length > 0;
    const hasBlocked = values.some((v) => blocked.has(v));

    const canContinue = hasAny && !hasBlocked;
    nextBtn.disabled = !canContinue;
    nextBtn.style.opacity = canContinue ? '1' : '0.55';

    errorBox.style.display = hasAny && hasBlocked ? 'flex' : 'none';
  }

  function atTop() { return scrollBox.scrollTop <= 0; }
  function updateToggle() {
    toggleBtn.classList.toggle('scrollPick__toggle--up', !atTop());
  }
  scrollBox.addEventListener('scroll', updateToggle);
  toggleBtn.addEventListener('click', () => {
    const target = atTop() ? scrollBox.scrollHeight : 0;
    scrollBox.scrollTo({ top: target, behavior: 'smooth' });
  });
  updateState();
  updateToggle();

  // Ensure at least ~6 rows are visible before scroll
  const firstRow = scrollBox.querySelector('.scrollRow');
  if (firstRow) {
    const rowHeight = firstRow.getBoundingClientRect().height || 44;
    scrollBox.style.maxHeight = (rowHeight * 6) + 'px';
  }
}


function escapeHtml(s) {
  return String(s).replace(/[&<>"']/g, (m) => ({
    "&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#039;"
  }[m]));
}

function renderCenterInfoStep(step, container) {
  container.innerHTML = `
    <div class="centerInfo">
      <h2 class="centerInfo__title">${escapeHtml(step.text || '')}</h2>
      <p class="centerInfo__subtitle">${escapeHtml(step.subtext || '')}</p>
    </div>
  `;

  const btn = createButton(step.buttonLabel || 'Continue');
  btn.classList.add('centerInfo__cta');
  btn.addEventListener('click', goToNextStep);
  container.appendChild(btn);
}



let GP_DETAILS_MODE = 'search'; // 'search' | 'manual'

function renderGpDetailsStep(step, container) {
  // restore stored object or default
  const stored = QUIZ_ANSWERS[step.id] && QUIZ_ANSWERS[step.id].value;
  const existing = (stored && typeof stored === 'object')
    ? stored
    : {
        mode: 'search',
        search_postcode: '',
        manual: {
          practice: '',
          address1: '',
          city: '',
          postcode: '',
          odsCode: ''
        }
      };

  GP_DETAILS_MODE = existing.mode || 'search';

  container.innerHTML = `
    <div class="gpCard">
      <h2 class="gpCard__title">${escapeHtml(step.text || "Can you share your GP’s details?")}</h2>
      <p class="gpCard__sub">${escapeHtml(step.subtext || "Search for your GP by entering your postcode.")}</p>

        <div class="gpCard__search" data-gp-search>
      <input class="gpCard__postcode" type="text" placeholder="Postcode"
             value="${escapeHtml(existing.search_postcode || '')}">
      <button class="gpCard__find" type="button">Find</button>
    </div>

    <!-- NEW: loading row -->
    <div class="gpCard__loading" data-gp-loading style="display:none;">
      <div class="gpCard__spinner"></div>
      <span>Searching practices...</span>
    </div>

    <div class="gpCard__results" data-gp-results></div>

      <p class="gpCard__noResults" data-gp-noresults style="display:none;">
        No GP practices found for that postcode. You can add your GP manually.
      </p>

      <div class="gpCard__manual" data-gp-manual style="display:none;">
        <input class="gpCard__input" data-field="practice" type="text"
               placeholder="GP Practice Name"
               value="${escapeHtml(existing.manual?.practice || '')}">
        <input class="gpCard__input" data-field="address1" type="text"
               placeholder="Address Line 1"
               value="${escapeHtml(existing.manual?.address1 || '')}">
        <input class="gpCard__input" data-field="city" type="text"
               placeholder="City"
               value="${escapeHtml(existing.manual?.city || '')}">
        <input class="gpCard__input" data-field="postcode" type="text"
               placeholder="Postcode"
               value="${escapeHtml(existing.manual?.postcode || '')}">
        <button class="gpCard__back" type="button">Back to Search</button>
      </div>

      <div class="gpCard__manualBar" data-gp-manualbar>
        <button class="gpCard__manualLink" type="button">+ Manual Add</button>
      </div>

      <div class="gpCard__info">
        <h4 class="gpCard__infoTitle">Why we ask</h4>
        <p class="gpCard__infoText">
          In order to ensure safe quality care, we need to confirm your GP’s details so we can let them
          know about your treatment. By providing this, you consent for this information to be shared
          with their office.
        </p>
      </div>
    </div>
  `;

  const postcodeInput = container.querySelector('.gpCard__postcode');
  const findBtn = container.querySelector('.gpCard__find');
  const noResults = container.querySelector('[data-gp-noresults]');
  const resultsBox = container.querySelector('[data-gp-results]');
  const loadingBox = container.querySelector('[data-gp-loading]'); // <-- NEW


  const manual = container.querySelector('[data-gp-manual]');
  const manualInputs = container.querySelectorAll('.gpCard__input');
  const backBtn = container.querySelector('.gpCard__back');

  const manualBar = container.querySelector('[data-gp-manualbar]');
  const manualLink = container.querySelector('.gpCard__manualLink');

  const manualPracticeInput = manual.querySelector('[data-field="practice"]');
  const manualAddressInput = manual.querySelector('[data-field="address1"]');
  const manualCityInput = manual.querySelector('[data-field="city"]');
  const manualPostcodeInput = manual.querySelector('[data-field="postcode"]');

  const confirmBtn = createButton('Confirm');
  confirmBtn.style.display = 'block';
  confirmBtn.style.margin = '24px auto 0';
  confirmBtn.disabled = true;
  confirmBtn.style.opacity = '0.55';
  container.appendChild(confirmBtn);

  function save() {
  recordAnswer(step.id, step.text, existing);
  console.log('GP details saved:', existing);
}

  function validateManual(showErrors) {
    const vals = {};
    let ok = true;

    manualInputs.forEach((inp) => {
      const key = inp.dataset.field;
      const v = inp.value.trim();
      vals[key] = v;
      if (!v) ok = false;
      if (showErrors && !v) inp.classList.add('gpCard__input--error');
      else inp.classList.remove('gpCard__input--error');
    });

    // keep existing odsCode if present
    vals.odsCode = existing.manual && existing.manual.odsCode ? existing.manual.odsCode : '';

    existing.manual = vals;

    confirmBtn.disabled = !ok;
    confirmBtn.style.opacity = ok ? '1' : '0.55';

    save();
    return ok;
  }

  function setMode(mode) {
    GP_DETAILS_MODE = mode;
    existing.mode = mode;

    if (mode === 'search') {
      manual.style.display = 'none';
      manualBar.style.display = 'flex';
      resultsBox.style.display = 'block';
      noResults.style.display = 'none';
      confirmBtn.disabled = true;          // confirm disabled in search mode
      confirmBtn.style.opacity = '0.55';
    } else {
      manual.style.display = 'block';
      manualBar.style.display = 'none';
      resultsBox.style.display = 'none';
      noResults.style.display = 'none';
      validateManual(false);
    }

    save();
  }

 async function performSearch(pc) {
  noResults.style.display = 'none';
  resultsBox.innerHTML = '';

  // show loader
  if (loadingBox) {
    loadingBox.style.display = 'flex';
  }

  const trimmed = pc.trim();
  existing.search_postcode = trimmed;
  save();

    if (!trimmed) {
      postcodeInput.focus();
      return;
    }

    if (!window.QUIZ_ENDPOINT && typeof QUIZ_ENDPOINT === 'undefined') {
      console.warn('QUIZ_ENDPOINT is not defined; GP search cannot call Apps Script.');
    }

    const originalLabel = findBtn.textContent;
    findBtn.disabled = true;
    findBtn.textContent = 'Searching...';

    try {
      const url = `${QUIZ_ENDPOINT}?action=ods_search&postcode=${encodeURIComponent(trimmed)}`;
      const res = await fetch(url, { method: 'GET' });
      if (!res.ok) throw new Error('HTTP ' + res.status);

      const data = await res.json();
      const items = (data && data.ok && Array.isArray(data.items)) ? data.items : [];

      if (!items.length) {
        noResults.textContent = 'No GP practices found for that postcode. You can add your GP manually.';
        noResults.style.display = 'block';
        return;
      }
items.forEach((item) => {
  const name = item.name || item.Name || 'Practice';

  // Try multiple common property names – adjust if needed
  const address1 =
    item.address1 ||
    item.Address1 ||
    item.AddressLine1 ||
    item.address ||
    '';
  const city =
    item.city ||
    item.City ||
    item.town ||
    item.Town ||
    '';
  const postcode =
    item.postcode ||
    item.PostCode ||
    item.postCode ||
    '';

  const lineParts = [address1, city, postcode].filter(Boolean);
  const line = lineParts.join(', ');

  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'gpResult';
  btn.innerHTML =
    `<div class="gpResult__name">${escapeHtml(name)}</div>` +
    (line ? `<div class="gpResult__meta">${escapeHtml(line)}</div>` : '');

  btn.addEventListener('click', () => {
    // Fill all four manual fields from this record
    existing.mode = 'manual';
    existing.manual = {
      practice: name,
      address1,
      city,
      postcode,
      odsCode: item.odsCode || item.OdsCode || ''
    };

    if (manualPracticeInput) manualPracticeInput.value = existing.manual.practice;
    if (manualAddressInput) manualAddressInput.value = existing.manual.address1;
    if (manualCityInput) manualCityInput.value = existing.manual.city;
    if (manualPostcodeInput) manualPostcodeInput.value = existing.manual.postcode;

    save();
    setMode('manual');
    validateManual(false);
  });

  resultsBox.appendChild(btn);
});
    } catch (err) {
      console.error('ODS search failed', err);
      noResults.textContent =
        'Sorry, something went wrong searching. Please try again or add your GP manually.';
      noResults.style.display = 'block';
    } finally {
  findBtn.disabled = false;
  findBtn.textContent = originalLabel;

  // hide loader
  if (loadingBox) {
    loadingBox.style.display = 'none';
  }
}
  }

  // Events
  postcodeInput.addEventListener('input', () => {
    existing.search_postcode = postcodeInput.value.trim();
    noResults.style.display = 'none';
    save();
  });

  postcodeInput.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      performSearch(postcodeInput.value);
    }
  });

  findBtn.addEventListener('click', () => {
    performSearch(postcodeInput.value);
  });

  manualInputs.forEach((inp) => inp.addEventListener('input', () => validateManual(false)));
  manualInputs.forEach((inp) => inp.addEventListener('blur', () => validateManual(true)));

  manualLink.addEventListener('click', () => setMode('manual'));
  backBtn.addEventListener('click', () => setMode('search'));

  confirmBtn.addEventListener('click', () => {
    if (GP_DETAILS_MODE !== 'manual') return;
    if (!validateManual(true)) return;
    goToNextStep();
  });

  // initial mode
  setMode(existing.mode || 'search');
}


function renderDobConfirmStep(step, container) {
  const title = document.createElement('h2');
  title.textContent = step.text || 'One final thing...';
  title.style.textAlign = 'center';
  title.style.marginBottom = '16px';
  container.appendChild(title);

  const card = document.createElement('div');
  card.className = 'quiz-info-card';
  card.style.maxWidth = '520px';
  card.style.margin = '0 auto';
  card.innerHTML = `
    <p style="margin:0 0 12px;">
      I confirm that any medication prescribed is for my personal use only, that my answers to all
      questions are honest and truthful, and that I understand and will inform myself of the
      treatment’s risks, benefits, and alternatives.
    </p>
    <label class="quiz-input-label" style="display:block; margin-bottom:6px;">Date of Birth</label>
    <div class="quiz-input-wrap" data-dob-wrap>
      <input type="text" class="quiz-input" placeholder="dd/mm/yyyy" data-dob-input>
    </div>
    <p style="margin:8px 0 0; font-size:13px; color:rgba(43,43,43,.7);">
      By entering your date of birth, you confirm the above statement.
    </p>
  `;
  container.appendChild(card);

  const inputWrap = card.querySelector('[data-dob-wrap]');
  const input = card.querySelector('[data-dob-input]');

  // Restore previous value if user comes back
  const stored = QUIZ_ANSWERS[step.id] && QUIZ_ANSWERS[step.id].value;
  if (stored) input.value = stored;

  const btn = createButton('Continue');
  btn.style.display = 'block';
  btn.style.margin = '24px auto 0';
  btn.disabled = true;
  btn.style.opacity = '0.55';
  container.appendChild(btn);

  function formatDob(raw) {
    const digits = raw.replace(/\D/g, '').slice(0, 8);
    if (!digits) return '';
    if (digits.length <= 2) return digits;
    if (digits.length <= 4) return digits.slice(0, 2) + '/' + digits.slice(2);
    return (
      digits.slice(0, 2) +
      '/' +
      digits.slice(2, 4) +
      '/' +
      digits.slice(4)
    );
  }

  function isValidDob(val) {
    const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(val);
    if (!m) return false;
    const day = +m[1];
    const month = +m[2];
    const year = +m[3];
    if (month < 1 || month > 12) return false;
    if (day < 1 || day > 31) return false;
    const thisYear = new Date().getFullYear();
    if (year < 1900 || year > thisYear) return false;
    return true;
  }

 function updateState(showErrors) {
  const val = input.value.trim();
  const ok = isValidDob(val);

  let errorMessage = '';
  let isUnderage = false;

  if (ok) {
    const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(val);
    const day = +m[1];
    const month = +m[2];
    const year = +m[3];

    const today = new Date();
    const birthDate = new Date(year, month - 1, day);
    let age = today.getFullYear() - birthDate.getFullYear();
    const mDiff = today.getMonth() - birthDate.getMonth();
    if (mDiff < 0 || (mDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    if (age < 18) {
      isUnderage = true;
      errorMessage = 'You must be at least 18 years old to continue.';
    }
  }

  if (!ok || isUnderage) {
    if (showErrors) inputWrap.classList.add('quiz-input-error');
    btn.disabled = true;
    btn.style.opacity = '0.55';
  } else {
    inputWrap.classList.remove('quiz-input-error');
    btn.disabled = false;
    btn.style.opacity = '1';
  }

  // 🆕 Show error inside quiz-hw-error element if needed
  let errorBox = card.querySelector('[data-dob-error]');
  if (!errorBox) {
    errorBox = document.createElement('div');
    errorBox.setAttribute('data-dob-error', 'true');
    errorBox.className = 'quiz-hw-error';
    errorBox.style.display = 'none';
    errorBox.innerHTML = `
      <div class="quiz-hw-error__icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
             viewBox="0 0 24 24" fill="none" stroke="currentColor"
             stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
             aria-hidden="true">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" x2="12" y1="8" y2="12"></line>
          <line x1="12" x2="12.01" y1="16" y2="16"></line>
        </svg>
      </div>
      <div class="quiz-hw-error__text">You must be at least 18 years old to continue.</div>
    `;
    card.appendChild(errorBox);
  }

  if (isUnderage) {
    errorBox.style.display = 'flex';
  } else {
    errorBox.style.display = 'none';
  }

  if (val) {
    recordAnswer(step.id, 'Date of Birth', val);
  }
}

  input.addEventListener('input', () => {
    const formatted = formatDob(input.value);
    input.value = formatted;
    updateState(false);
  });

  input.addEventListener('blur', () => updateState(true));

 // Add THIS line just before btn.addEventListener:
let DOB_SUBMITTING = false;

btn.addEventListener('click', async () => {
  updateState(true);

  // guard against double click / double tap
  if (btn.disabled || DOB_SUBMITTING) return;

  DOB_SUBMITTING = true;
  btn.disabled = true;
  btn.style.opacity = '0.55';

  const val = input.value.trim();
  recordAnswer(step.id, 'Date of Birth', val);

  if (typeof submitQuizToAppsScript === 'function') {
    try {
      await submitQuizToAppsScript(null);
    } catch (e) {
      // ignore network errors; don't block user
    }
  }

  goToNextStep();
});
}

function resolveSelectedProduct(selectedId) {
  if (selectedId === 'wegovy-pill' || selectedId === 'wegovy-injection') {
    return {
      product: TREATMENT_PRODUCTS.wegovy,
      form: TREATMENT_PRODUCTS.wegovy.forms[selectedId === 'wegovy-pill' ? 'pill' : 'injection']
    };
  }

  return { product: TREATMENT_PRODUCTS[selectedId] || TREATMENT_PRODUCTS.mounjaro, form: null };
}

function renderOtherOptionCard(p, currentProductId, currentFormKey) {
  if (p.id === 'wegovy') {
    let mode = p.defaultForm || 'injection';
    if (currentProductId === 'wegovy' && currentFormKey) {
      mode = currentFormKey === 'pill' ? 'injection' : 'pill';
    }
    const active = p.forms[mode];

    return `
      <div class="quiz-result-modal__option" data-product-id="wegovy-${mode}">
        <div class="quiz-result-modal__option-main">
          <div class="quiz-result-modal__text">
            <p class="quiz-result-modal__option-name">${p.nameHtml}</p>
            <p class="quiz-result-modal__option-sub">${active.subtitle}</p>
          </div>

          <img class="quiz-result-modal__image" src="${active.modalImage || active.image}" alt="Wegovy" loading="lazy">

          <span class="quiz-result-modal__pill">${active.price}</span>
        </div>

        <div class="quiz-mode-toggle" data-wegovy-toggle>
          <button type="button" class="quiz-mode-toggle__btn is-active" data-mode="injection">Injection</button>
          <button type="button" class="quiz-mode-toggle__btn" data-mode="pill">Pill</button>
        </div>

        <button type="button" class="xo-quiz-button quiz-result-modal__select">
          <span>Select</span>
        </button>
      </div>
    `;
  }

const SUBSTANCE_BY_ID = {
    mounjaro: 'Tirzepatide',
    orlos: 'Orlistat',
    foundayo: 'Orforglipron'
  };

  return `
    <div class="quiz-result-modal__option" data-product-id="${p.id}">
      <div class="quiz-result-modal__option-main">
        <div class="quiz-result-modal__text">
          <p class="quiz-result-modal__option-name">${p.nameHtml}</p>
          <p class="quiz-result-modal__option-sub">${SUBSTANCE_BY_ID[p.id] || ''}</p>
        </div>

        <img class="quiz-result-modal__image" src="${p.modalImage || p.image}" alt="${p.nameHtml.replace(/<[^>]+>/g, '')}" loading="lazy">

        <span class="quiz-result-modal__pill">${p.price}</span>
      </div>

      <button type="button" class="xo-quiz-button quiz-result-modal__select">
        <span>Select</span>
      </button>
    </div>
  `;
}

function renderTreatmentResult(selectedId = 'mounjaro') {
  setProgressPercent(100);
if (resultScrollCleanup) {
  resultScrollCleanup();
  resultScrollCleanup = null;
}
  // Use the same full-page quiz layout as other steps (no extra top margin)
  const quizShell = root.closest('.xo-quiz-shell');
  if (quizShell) {
    quizShell.classList.remove('xo-quiz-shell--result');
  }

  // Keep the theme header hidden even on the result screen
  const headerSection = document.getElementById('shopify-section-header');
  if (headerSection) {
    headerSection.style.display = 'none';
  }

const resolved = resolveSelectedProduct(selectedId);
const product = resolved.product;
const active = resolved.form || product;

// Which Wegovy form (if any) is currently active
const currentFormKey =
  product.id === 'wegovy'
    ? (active.id === 'wegovy-pill' ? 'pill' : 'injection')
    : null;

// Display name e.g. "Wegovy® Pill" / "Wegovy® Injection" / "Mounjaro®"
const displayName =
  product.id === 'wegovy' && active.label
    ? `${product.nameHtml} ${active.label}`
    : product.nameHtml;

// Tags specific to the active form, falling back to product-level tags
const tags = active.tags || product.tags;

// Always include Wegovy as an "other option" (so user can switch pill/injection),
// and exclude the current non-Wegovy product from the list
const others = Object.values(TREATMENT_PRODUCTS).filter(
  (p) => p.id === 'wegovy' || p.id !== product.id
);

const metrics = computeJourneyMetrics(active.id || product.id);
const currentKg = metrics && metrics.weightKg ? Math.round(metrics.weightKg) : 70;
const lossKg = metrics && metrics.lossKg ? metrics.lossKg.toFixed(1) : '15.8';

const allStrengths = active.strengths || [];
const usingMedAnswer = QUIZ_ANSWERS['weight.using_medication'];
const isUsingMedication = usingMedAnswer && usingMedAnswer.value === 'yes';
const visibleStrengths = isUsingMedication
  ? allStrengths
  : allStrengths.filter((s) => s.isStarting);

let selectedStrengthId =
  active.startingStrengthId ||
  visibleStrengths.find((s) => s.isStarting)?.id ||
  visibleStrengths[0]?.id ||
  null;

const getSelectedStrength = () =>
  (active.strengths || []).find((s) => s.id === selectedStrengthId) || null;

 const ctaLabel = 'Continue with this plan';

  root.innerHTML = '';
  const wrap = document.createElement('div');
  wrap.className = 'quiz-result';
  function renderTag(tag) {
  // Most effective → tick in white circle
  if (/most effective/i.test(tag.label)) {
    return `
      <span class="quiz-result__tag quiz-result__tag--${tag.variant}">
        <span class="quiz-result__tagIconCircle">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
               viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
               aria-hidden="true">
            <path d="M20 6 9 17l-5-5"></path>
          </svg>
        </span>
        <span class="quiz-result__tagText">${tag.label}</span>
      </span>
    `;
  }

  // In stock → cart icon
  if (/in stock/i.test(tag.label)) {
    return `
      <span class="quiz-result__tag quiz-result__tag--${tag.variant}">
        <span class="quiz-result__tagIcon">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
               viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
               aria-hidden="true">
            <circle cx="8" cy="21" r="1"></circle>
            <circle cx="19" cy="21" r="1"></circle>
            <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"></path>
          </svg>
        </span>
        <span class="quiz-result__tagText">${tag.label}</span>
      </span>
    `;
  }

  // default tag
  return `
    <span class="quiz-result__tag quiz-result__tag--${tag.variant}">
      <span class="quiz-result__tagText">${tag.label}</span>
    </span>
  `;
}
  wrap.innerHTML = `
    <div class="quiz-result__hero">
      <p class="quiz-result__subtitle">A clinician may consider this match for you:</p>
<div class="quiz-result__tags">
  ${tags.map(renderTag).join('')}
</div>

    <h2 class="quiz-result__title">${displayName}</h2>

  <div class="quiz-result__image">
        <img src="${active.image || product.image}" alt="${displayName.replace(/<[^>]+>/g, '')}">
      </div>
        
      <div class="quiz-result__stats">
        <div class="quiz-result__stat">
          <p class="quiz-result__stat-label">Your weight profile</p>
          <p class="quiz-result__stat-value">${currentKg} kg</p>
        </div>
                <div class="quiz-result__stat">
  <!-- Line 1: label -->
  <p class="quiz-result__stat-label">Potential weight loss</p>

  <!-- Line 2: value + arrow -->
  <p class="quiz-result__stat-value">
    ${lossKg} kg
    <span class="quiz-result__stat-arrow" aria-hidden="true">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
           viewBox="0 0 24 24" fill="none" stroke="currentColor"
           stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
           class="lucide lucide-arrow-right w-4 h-4 text-[#A890FE] rotate-90">
        <path d="M5 12h14"></path>
        <path d="m12 5 7 7-7 7"></path>
      </svg>
    </span>
  </p>
</div>
      </div>

            <div class="quiz-result__strengths">
  <div class="quiz-result__strengths-header">
  <p class="quiz-result__strengths-label">Select strength</p>
  <span class="quiz-result__strengths-pill" data-starting-pill>
    Starting strength
  </span>
</div>

    <!-- Trigger (what user taps) -->
    <div class="quiz-result__selectShell" data-strength-trigger>
      <span class="quiz-result__selectValue" data-strength-display>
        ${
          (
            visibleStrengths.find((s) => s.id === selectedStrengthId) ||
            visibleStrengths[0] ||
            {}
          ).label
            .split('–')[0]
            .trim()
        }
      </span>
      <span class="quiz-result__selectArrow">▾</span>
    </div>
  </div>

  <!-- Strength dialog -->
  <div class="quiz-strength-modal" aria-hidden="true">
    <div class="quiz-strength-modal__backdrop"></div>
    <div class="quiz-strength-modal__dialog" role="dialog" aria-modal="true">
      ${visibleStrengths
        .map(
          (s) => `
        <button
          type="button"
          class="quiz-strength-modal__option ${
            s.id === selectedStrengthId ? 'is-selected' : ''
          }"
          data-strength-id="${s.id}"
        >
          <span class="quiz-strength-modal__check">✓</span>
          <span class="quiz-strength-modal__label">
            ${s.label.split('–')[0].trim()}
          </span>
        </button>
      `
        )
        .join('')}
    </div>
  </div>


          <div class="quiz-result__bottom">
<p class="quiz-result__small-copy">${active.doseCopy || product.doseCopy}</p>
  <p class="quiz-result__price">${active.price || product.price}</p>

<button
  class="xo-quiz-button quiz-result__primary-cta"
  type="button"
  data-result-primary
  data-product-id="${active.id || product.id}"
>
    <span>${ctaLabel}</span>
  </button>
</div>

<!-- NEW: move Explore button up into the content flow -->
<button class="quiz-result__secondary-cta" type="button" data-result-other>
  Explore other treatment options
</button>

    <div class="quiz-accordion">
      ${product.accordions
        .map(
          (acc, idx) => `
        <div class="quiz-accordion__item" data-acc-index="${idx}">
          <button class="quiz-accordion__header" type="button">
            <span>${acc.title}</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                 viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                 class="quiz-accordion__icon" aria-hidden="true">
              <path d="m6 9 6 6 6-6"></path>
            </svg>
          </button>
          <div class="quiz-accordion__content">
            <p>${acc.content}</p>
          </div>
        </div>`
        )
        .join('')}
    </div>

    <p class="quiz-result__footer-note">
      A clinician will review all of your responses to determine if this treatment option is a good fit.
    </p>

    <!-- Keep your modal so user can change to another product -->
    <div class="quiz-result-modal" aria-hidden="true">
      <div class="quiz-result-modal__backdrop"></div>
      <div class="quiz-result-modal__dialog" role="dialog" aria-modal="true">
        <div class="quiz-result-modal__header">
          <h3 class="quiz-result-modal__title">Other treatment options</h3>
          <button type="button" class="quiz-result-modal__close" data-modal-close>&times;</button>
        </div>
        <p class="quiz-result-modal__subtitle">
          Based on your profile, here are other options available.
        </p>
<div class="quiz-result-modal__options">
  ${others.map((p) => renderOtherOptionCard(p, product.id, currentFormKey)).join('')}
</div>
</div>
    </div>
  </div>
`;
root.appendChild(wrap);

if (!document.getElementById('quiz-wa-bubble')) {
  const wa = document.createElement('a');
  wa.id = 'quiz-wa-bubble';
  wa.href = 'https://wa.me/YOUR_NUMBER';
  wa.target = '_blank';
  wa.rel = 'noopener noreferrer';
  wa.setAttribute('aria-label', 'Chat on WhatsApp');
  wa.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="white" aria-hidden="true">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
      <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.558 4.126 1.533 5.858L.057 23.428a.75.75 0 0 0 .916.916l5.57-1.476A11.953 11.953 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.75a9.705 9.705 0 0 1-4.953-1.355l-.355-.211-3.676.973.986-3.607-.232-.371A9.718 9.718 0 0 1 2.25 12C2.25 6.615 6.615 2.25 12 2.25S21.75 6.615 21.75 12 17.385 21.75 12 21.75z"/>
    </svg>
  `;
  wa.style.cssText = `
    position: fixed;
    bottom: 90px;
    right: 20px;
    width: 52px;
    height: 52px;
    background: #25D366;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(0,0,0,0.25);
    z-index: 9999;
    text-decoration: none;
  `;
  document.body.appendChild(wa);
}

// --- elements to update when strength changes ---
const heroImgEl = root.querySelector('.quiz-result__image img');
const priceEl   = root.querySelector('.quiz-result__price');

function updateStrengthUI() {
  const strength = getSelectedStrength();
  if (!strength) return;

  const baseText = strength.priceText || product.price;
  const baseVal  = parseMonthlyPrice(baseText);
  let finalVal   = baseVal;

  if (priceEl) {
    if (FROM_SNOWBALL) {
      finalVal = Math.max(0, baseVal - 30);
      // Show strikethrough original + discounted price
      priceEl.innerHTML = `
        <span style="
          text-decoration: line-through;
          color: #E53E3E;
          opacity: 0.85;
          font-weight: 700;
          margin-right: 6px;
          font-size: 0.9em;
        ">${formatMonthlyPrice(baseVal)}</span><span style="
          font-weight: 900;
        ">${formatMonthlyPrice(finalVal)}</span>
      `;
    } else {
      // Normal price - no discount
      priceEl.textContent = formatMonthlyPrice(baseVal);
    }
  }

if (heroImgEl) {
  heroImgEl.src = strength.heroImage || active.image || product.image;
}

const startingPill = root.querySelector('[data-starting-pill]');
  if (startingPill) {
    startingPill.style.display = strength.isStarting ? '' : 'none';
  }
}

// Initial call so price is correct as soon as the result renders
updateStrengthUI();

// Hide sticky bottom on mobile when footer is reached
const stickyBottom = root.querySelector('.quiz-result__bottom');
if (stickyBottom) {
  const footer = document.querySelector('footer') || document.querySelector('.site-footer');

function handleScroll() {
    if (window.innerWidth > 768) {
      stickyBottom.classList.remove('quiz-result__bottom--hidden');
      return;
    }
    // Footer hidden (e.g. quiz page) — keep sticky visible always
    if (!footer || !footer.offsetHeight) {
      stickyBottom.classList.remove('quiz-result__bottom--hidden');
      return;
    }
    const footerRect = footer.getBoundingClientRect();
    stickyBottom.classList.toggle('quiz-result__bottom--hidden', footerRect.top < window.innerHeight);
  }

  window.addEventListener('scroll', handleScroll, { passive: true });
  handleScroll(); // initial

  resultScrollCleanup = () => window.removeEventListener('scroll', handleScroll);
}
  const strengthDisplay = root.querySelector('[data-strength-display]');
const strengthTrigger = root.querySelector('[data-strength-trigger]');
const strengthModal = root.querySelector('.quiz-strength-modal');
const strengthModalBackdrop = root.querySelector('.quiz-strength-modal__backdrop');
const strengthOptionButtons = root.querySelectorAll('.quiz-strength-modal__option');

function openStrengthModal() {
  if (!strengthModal) return;
  strengthModal.classList.add('quiz-strength-modal--open');
  strengthModal.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
}

function closeStrengthModal() {
  if (!strengthModal) return;
  strengthModal.classList.remove('quiz-strength-modal--open');
  strengthModal.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

// Open dialog when user taps the pill
if (strengthTrigger) {
  strengthTrigger.addEventListener('click', (e) => {
    e.preventDefault();
    openStrengthModal();
  });
}

// Close when tapping outside
if (strengthModalBackdrop) {
  strengthModalBackdrop.addEventListener('click', closeStrengthModal);
}

// Handle selecting a strength
strengthOptionButtons.forEach((btn) => {
  btn.addEventListener('click', () => {
    const id = btn.getAttribute('data-strength-id');
    if (!id) return;

    selectedStrengthId = id;

    // Visual state in dialog
    strengthOptionButtons.forEach((b) =>
      b.classList.toggle('is-selected', b === btn)
    );

    // Update display text + price/image
    const strength = getSelectedStrength();
    if (strength && strengthDisplay) {
      strengthDisplay.textContent = strength.label.split('–')[0].trim();
    }
    updateStrengthUI();

    closeStrengthModal();
  });
});

    
  // Accordions
  root.querySelectorAll('.quiz-accordion__item').forEach((item) => {
    const header = item.querySelector('.quiz-accordion__header');
    header.addEventListener('click', () => {
      item.classList.toggle('is-open');
    });
  });

  

  // Modal wiring (change product)
  const otherBtn = root.querySelector('[data-result-other]');
  const modal = root.querySelector('.quiz-result-modal');
  const backdrop = modal.querySelector('.quiz-result-modal__backdrop');
  const closeBtns = modal.querySelectorAll('[data-modal-close]');

function openModal() {
    modal.classList.add('quiz-result-modal--open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeModal() {
    modal.classList.remove('quiz-result-modal--open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  otherBtn.addEventListener('click', openModal);
  backdrop.addEventListener('click', closeModal);
  closeBtns.forEach((btn) => btn.addEventListener('click', closeModal));

  root.querySelectorAll('[data-wegovy-toggle]').forEach((toggleEl) => {
  const card = toggleEl.closest('.quiz-result-modal__option');
  requestAnimationFrame(() => {
    card.style.minHeight = card.offsetHeight + 'px';
  });
  const optionBtn = card.querySelector('.quiz-result-modal__select');
  const img = card.querySelector('.quiz-result-modal__image');
  const sub = card.querySelector('.quiz-result-modal__option-sub');
  const pill = card.querySelector('.quiz-result-modal__pill');

  toggleEl.querySelectorAll('[data-mode]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const mode = btn.getAttribute('data-mode');
      const activeForm = TREATMENT_PRODUCTS.wegovy.forms[mode];
      if (!activeForm) return;

      toggleEl.querySelectorAll('[data-mode]').forEach((x) => x.classList.remove('is-active'));
      btn.classList.add('is-active');

      card.setAttribute('data-product-id', activeForm.id);
      optionBtn.setAttribute('data-product-id', activeForm.id);

      if (img) img.src = activeForm.modalImage || activeForm.image;
      if (sub) sub.textContent = activeForm.subtitle;
      if (pill) pill.textContent = activeForm.price;
    });
  });
});

modal.querySelectorAll('.quiz-result-modal__option').forEach((optEl) => {
    const selectBtn = optEl.querySelector('.quiz-result-modal__select');
    selectBtn.addEventListener('click', () => {
      const pid = optEl.getAttribute('data-product-id'); // ← read live from DOM
      closeModal();
      renderTreatmentResult(pid);
    });
  });

   // Store selected product as a virtual answer
recordAnswer(
  `${QUIZ_CATEGORY}.selected_product`,
  'Selected treatment product',
  active.id || product.id
);

const primaryBtn = root.querySelector('[data-result-primary]');
if (primaryBtn) {

  checkPlanCartLock(primaryBtn);
 if (typeof attachQuizCartRemoveSync === 'function') attachQuizCartRemoveSync();


  primaryBtn.addEventListener('click', () => {
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then((res) => res.json())
      .then((cart) => {
        const hasItem = cart && cart.item_count > 0;
        if (hasItem) {
          openCartDrawer();
          return;
        }
        const strength = getSelectedStrength();
        if (!strength) {
          alert('Please choose a plan.');
          return;
        }
        addPlanToCart(product, strength, primaryBtn);
      })
      .catch((err) => {
        console.error('Cart check failed on quiz result click', err);
        const strength = getSelectedStrength();
        if (!strength) {
          alert('Please choose a plan.');
          return;
        }
        addPlanToCart(product, strength, primaryBtn);
      });
  });

// In the static out_of_stock check — add the isWegovyPill guard
const activeStatus = active.status || product.status;
if (activeStatus === 'out_of_stock') {
  primaryBtn.disabled = true;
  primaryBtn.classList.add('xo-quiz-button--disabled');
  const span = primaryBtn.querySelector('span');
  const isWegovyPill = product.id === 'wegovy' && (active.id || '') === 'wegovy-pill';
  if (span && !isWegovyPill) span.textContent = 'Sold out'; // Wegovy pill keeps 'Coming Soon'
}

  // 2. Live Shopify stock check
  const currentStrength = getSelectedStrength();
  console.log('Current strength:', currentStrength);

  if (
    currentStrength &&
    currentStrength.handle &&
    typeof fetchProductAvailability === 'function'
  ) {
    fetchProductAvailability(currentStrength.handle)
      .then((map) => {
        if (!map) return;
 if (map[currentStrength.variantId] === false) {
  primaryBtn.disabled = true;
  primaryBtn.classList.add('xo-quiz-button--disabled');

  const span = primaryBtn.querySelector('span');
  if (span) span.textContent = 'Sold out';
}
      })
      .catch((err) => {
        console.warn('Stock check failed', err);
      });
  }
}
}
function lockPlanButton(btn) {
  if (!btn) return;
  btn.setAttribute('data-locked', 'true');
  btn.classList.add('xo-quiz-button--disabled');
  const span = btn.querySelector('span');
  if (span) span.textContent = 'Only 1 Product Allowed';
}

function unlockPlanButton(btn) {
  if (!btn) return;

  const selectedId =
    btn.getAttribute('data-product-id') ||
    document.querySelector('[data-result-primary]')?.getAttribute('data-product-id');
    console.log('unlockPlanButton:', selectedId);

   const span = btn.querySelector('span');
  if (!span) return;

  // Orlos
  if (selectedId === 'orlos') {
    span.textContent = 'Sold out';
    btn.classList.add('xo-quiz-button--disabled');
    btn.disabled = true;
    return;
  }

  btn.removeAttribute('data-locked');
  btn.classList.remove('xo-quiz-button--disabled');
  btn.disabled = false;

  span.textContent = 'Continue with this plan';
}

// Check current cart; if there is already any item, lock the plan button
function checkPlanCartLock(btn) {
  if (!btn) return;
  fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
    .then((res) => res.json())
    .then((cart) => {
      if (cart && cart.item_count > 0) {
        lockPlanButton(btn);
      } else {
        unlockPlanButton(btn);
      }
    })
    .catch(() => {
      // if request fails, allow the user to try
      unlockPlanButton(btn);
    });
}

function openCartDrawer() {
  // Click the actual cart link inside .hd-cart-btn first
  const trigger =
    document.querySelector('.hd-cart-btn a.icon-cart-active') || // Unicorn/cart link
    document.querySelector('.hd-cart-btn') ||                    // wrapper as fallback
    document.querySelector('[data-cart-toggle]') ||
    document.querySelector('[data-drawer-open="#CartDrawer"]') ||
    document.querySelector('.header__icon--cart button') ||
    document.querySelector('.js-drawer-open-cart');

  if (trigger) {
    trigger.click();  // Unicorn should intercept and open drawer; otherwise go to /cart
  } else {
    window.location.href = '/cart';
  }
}

function addPlanToCart(product, strength, btn) {
  if (!strength.variantId) {
    console.warn('No variantId configured for strength', product.id, strength);
    alert('This plan is not fully configured yet. Please contact support.');
    return;
  }

  const payload = {
    id: strength.variantId,
    quantity: 1
  };

  if (strength.sellingPlanId) {
    payload.selling_plan = strength.sellingPlanId;
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(payload)
  })
    .then(async (res) => {
      const text = await res.text();
      if (!res.ok) {
        console.error('Add to cart failed', res.status, text);
        throw new Error('Add to cart failed: ' + res.status);
      }
      // Parse or ignore response; Unicorn will handle cart UI
      try {
        return JSON.parse(text);
      } catch (e) {
        return text;
      }
    })
    .then(() => {
      // Lock the quiz button so user can't add again
      lockPlanButton(btn);

      // DO NOT manually open cart drawer here.
      // Unicorn / theme script will open it automatically
      // when it sees the /cart/add.js request succeed.
    })
    .catch((err) => {
      console.error(err);
      alert('Sorry, we could not add this plan to your cart. Please try again.');
    });
}

async function submitQuizToAppsScript(selectedProductId) {
  const journey = computeJourneyMetrics(selectedProductId || null);

  const emailAnswer = QUIZ_ANSWERS['weight.email'];
  const email = emailAnswer && emailAnswer.value ? String(emailAnswer.value) : '';

  const payload = {
    email,
    category: QUIZ_CATEGORY,
    quiz_version: QUIZ_VERSION,
    source_url: window.location.href,
    answers: QUIZ_ANSWERS,
    result: {
      journey,
      selected_product: selectedProductId || null
    }
  };

  try {
    if (QUIZ_ENDPOINT) {
      await fetch(QUIZ_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload),
        mode: 'no-cors',
        keepalive: true
      });
    }
  } catch (e) {
    // ignore network errors – don't block UI
  }
}

function onQuizComplete() {
  // After last quiz step (DOB), show treatment match screen
  renderTreatmentResult('mounjaro');
}

    // ---------- INIT ----------
    // intro visible, quiz hidden
    if (root) root.style.display = 'none';
    if (intro) intro.style.display = '';

    const raw = progressText ? progressText.textContent : '4%';
    const introPercent = parseInt(String(raw).replace('%', ''), 10) || 4;
    setProgressPercent(introPercent);

    if (introButton) {
      introButton.addEventListener('click', () => {
        if (intro) intro.style.display = 'none';
        if (root) root.style.display = '';
        currentStepIndex = 0;
        renderCurrentStep();
      });
    }

    if (backButton) {
      backButton.addEventListener('click', () => {
        if (root && root.style.display === 'none') {
          window.history.back();
          return;
        }

        const steps = getSteps();
const step = steps[currentStepIndex];
if (step && step.id === 'weight.current_situation' && CURRENT_SITUATION_MODE === 'safety') {
  CURRENT_SITUATION_MODE = 'options';
  renderCurrentStep();
  return;
}

       if (currentStepIndex > 0) {
  currentStepIndex -= 1;
  renderCurrentStep();
  scrollQuizToTop();
  return;
}
        if (intro) intro.style.display = '';
        if (root) root.style.display = 'none';
        setProgressPercent(introPercent);
      });
    }
  });
})();